<template>
    <div v-if="$route.meta.isPublicView || user">
        <div v-if="!$route.meta.isPublicView" class="search_wrapper">
            <div style="display: flex; flex-direction: row; align-items: flex-end; flex-wrap:wrap; flex:auto;">
                <!-- filters -->
                <div v-for="(filter, index) in filters" class="filter">
                    <div style="display:flex; flex-direction: column">
                        <div class="field_label w100">{{ getQuestionLabel(filter.column) }}:</div>
                        <div class="w200"
                            :class="{field_chip: !filter.isExcluded, field_chip_exclude: filter.isExcluded}"
                            @click="showFilter">
                            <span class="chip_text">{{filter.value.valueToShow }}</span>
                            <va-button style="margin-top: -2px;" class="chip-btn" type="subtle-link"
                                @click.native="removeFilter(index)">
                                <va-icon color="white" type="times"></va-icon>
                            </va-button>
                        </div>
                    </div>
                </div>

                <!-- ------------------------------------------------------------------------------------------ -->

                <va-dropdown class="filter_drop_down" @show="() => dropDown='first'" @hide="clearFields"
                    :click-close="false" effect="none" ref="filterFieldsDropDown">
                    <div slot="trigger">
                        <va-button class="filter_btn" type="info">
                            <va-icon type="plus"></va-icon>
                        </va-button>
                    </div>
                    <div v-if="dropDown=='first'">
                        <li class="fieldTitle" v-for="(field, index) in filterFields" v-if="!filterExists(field)"><a
                                @click="showConditions(field)">
                                {{ getLabel(field.label) }}</a></li>
                    </div>

                    <div v-if="dropDown=='second'" style="min-width: 300px">
                        <div style="padding: 20px">
                            <va-button @click.native="backToFields" class="filter_back_btn" type="subtle">
                                <va-icon type="chevron-left"></va-icon>
                            </va-button>

                            <va-checkbox v-model="isExcluded" class="exclude_checkbox"
                                v-if="(currentFilterField.type != 'single-option'  && currentFilterField.type != 'checkbox')">{{
                                _('Exclude') }}</va-checkbox>

                            <p class="filter_question">{{ getLabel(currentFilterField.label) }}</p>

                            <va-row>
                                <va-column :lg="12" :md="12" class="filter_value">
                                    <va-form-item style="width: 100%">
                                        <va-input @keyup.native.enter="createFilter"
                                            v-if="currentFilterField.type == 'text' || currentFilterField.type == 'textarea'"
                                            v-model="filterValue" showClean></va-input>

                                        <user-selection style="width: 100%"
                                            v-if="currentFilterField.type == 'createdBy'"
                                            v-bind:selected.sync="filterUsers" :showRequired="false" title=''
                                            :roles="getRoles" :department="currentDepartment" />

                                        <user-selection style="width: 100%"
                                            v-if="currentFilterField.type == 'approvalBy'"
                                            v-bind:selected.sync="filterApproverUsers" :showRequired="false" title=''
                                            :roles="getApprovalByRoles" :department="currentDepartment" />

                                        <div v-if="currentFilterField.type == 'date'">
                                            <div v-if="currentFilterField.field.isTime">
                                                <va-timepicker v-model="filterValue"
                                                    :hourRange="[hourRangeMin, hourRangeMax]"
                                                    :minuteRange="[minuteRangeMin, minuteRangeMax]"
                                                    :secondRange="[secondRangeMin, secondRangeMax]" />
                                            </div>
                                            <div v-else>
                                                <div v-if="currentFilterField.field.isHijri">
                                                    <date-picker style="padding-bottom: 10px" v-model="filterFromDate">
                                                    </date-picker>

                                                    <date-picker style="margin-top: 10px"
                                                        v-if="filterCondition == 'dateRange'" v-model="filterToDate">
                                                    </date-picker>
                                                </div>
                                                <div v-else>
                                                    <va-datepicker v-if="currentFilterField.type=='date'" v-model="
                                                        filterFromDate" :placeholder="_('From')" format="yyyy-MM-dd">
                                                    </va-datepicker>
                                                    <va-datepicker v-if="filterCondition == 'dateRange'"
                                                        style="margin-top: 10px" v-model="filterToDate"
                                                        :placeholder="_('To')" format="yyyy-MM-dd">
                                                    </va-datepicker>
                                                </div>
                                                <va-button v-if="filterCondition == 'dateRange'" class="shortcut-btns"
                                                    @click.native="lastSevenDays">
                                                    {{ _('Last seven Days') }}</va-button>
                                                <va-button v-if="filterCondition == 'dateRange'" class="shortcut-btns"
                                                    @click.native="prevMonth">{{ _('Prev Month') }}</va-button>
                                                <va-button v-if="filterCondition == 'dateRange'" class="shortcut-btns"
                                                    @click.native="thisMonth">{{ _('This Month') }}</va-button>

                                                <va-button v-if="filterCondition == 'dateRange'" class="shortcut-btns"
                                                    @click.native="lastThreeMonths">{{ _('Last three months') }}
                                                </va-button>
                                                <va-button v-if="filterCondition == 'dateRange'" class="shortcut-btns"
                                                    @click.native="prevYear">{{ _('Prev Year') }}</va-button>
                                                <va-button v-if="filterCondition == 'dateRange'" class="shortcut-btns"
                                                    @click.native="thisYear">{{ _('This Year') }}</va-button>
                                            </div>
                                        </div>

                                        <va-radio-group v-if="currentFilterField.type == 'single-option'"
                                            v-model="filterValue" vertical>
                                            <va-radio v-for="(option, index) in currentFilterField.options"
                                                :checked="index == 0" :label="option.value">
                                                {{ getOptionLabelForView(option) }}</va-radio>
                                        </va-radio-group>

                                        <va-checkbox-group v-if="currentFilterField.type == 'multiple-option'" vertical
                                            v-model="filterValue">
                                            <va-checkbox v-for="(option, index) in currentFilterField.options"
                                                :selected="index == 0" :label="option.value">{{
                                                getOptionLabelForView(option) }}</va-checkbox>
                                        </va-checkbox-group>

                                        <va-radio-group v-model="filterValue"
                                            v-if="currentFilterField.type == 'checkbox'">
                                            <va-radio label="true" checked>{{ _('Yes') }}</va-radio>
                                            <va-radio label="false">{{ _('No') }}</va-radio>
                                        </va-radio-group>

                                        <va-select v-if="currentFilterField.type == 'select'" v-model="filterValue"
                                            :placeholder="_('Select option')" :showSelected='false'
                                            :multiple="currentFilterField.field.multiple">
                                            <va-option v-for="option in currentFilterField.options"
                                                :label="getOptionLabelForView(option)" :value="option.value">{{
                                                getOptionLabelForView(option) }}</va-option>
                                        </va-select>

                                        <va-checkbox-group v-if="currentFilterField.type == 'status'" vertical
                                            v-model="filterValue">
                                            <va-checkbox checked label="pending">{{ _('Pending') }}</va-checkbox>
                                            <va-checkbox checked label="approved">{{ _('Approved') }}</va-checkbox>
                                            <va-checkbox checked label="rejected">{{ _('Rejected') }}</va-checkbox>
                                        </va-checkbox-group>

                                    </va-form-item>
                                </va-column>
                            </va-row>

                            <va-row>
                                <va-column :lg="12">
                                    <va-radio-group v-model="filterCondition"
                                        style="margin-left: 20px; flex-wrap: wrap;">
                                        <va-radio
                                            v-if="(currentFilterField.type == 'text' || currentFilterField.type == 'textarea') && currentFilterField.field.fieldType != 'number'"
                                            label="contains"
                                            :checked="currentFilterField.type == 'text' || currentFilterField.type == 'textarea'">
                                            {{ _('Contains') }}</va-radio>
                                        <va-radio
                                            v-if="(currentFilterField.type == 'text' || currentFilterField.type == 'textarea') && currentFilterField.field.fieldType != 'number'"
                                            label="exact">{{ _('Exact')
                                            }}</va-radio>

                                        <va-radio :checked="currentFilterField.type == 'date'"
                                            v-if="currentFilterField.type == 'date'  && !currentFilterField.field.isTime"
                                            label="date">{{ _('Date') }}
                                        </va-radio>
                                        <va-radio
                                            v-if="currentFilterField.type == 'date' && !currentFilterField.field.isTime"
                                            label="dateRange">{{
                                            _('Range') }}</va-radio>

                                    </va-radio-group>

                                </va-column>
                            </va-row>

                            <div>
                                <div style="display: flex; justify-content: flex-end;
                                                        align-items: baseline; margin-top:42px; margin-right:4px;">
                                    <va-button type="primary" @click.native="createFilter">{{ _('Create Filter') }}
                                    </va-button>

                                </div>
                            </div>
                        </div>
                    </div>
                </va-dropdown>

                <va-button
                    v-if="(user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes(section + '-editor')) && (viewedFilterObj || filters.length != 0)"
                    type="default" style="margin-left: 10px; margin-top:10px; zoom: .85"
                    @click.native="saveFilterModal">
                    {{ viewedFilterObj ? _('UPDATE') :_('SAVE') }}</va-button>
                <va-button
                    v-if="(user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes(section + '-editor')) && (viewedFilterObj || (viewedFilterObj && filters.length == 0))"
                    type="default" style="margin-left: 10px; margin-top:10px; zoom: .85" @click.native="deleteFilter">
                    {{  _('DELETE') }}</va-button>

                <va-modal :title="_('Filter title')" width="900px" ref="filtersModal" :backdrop-clickable="true"
                    @confirm="saveFilters">
                    <div slot="body">
                        <div style="display: flex; justify-content: space-between">
                            <va-input :rules="[{type:'required'}]" size="lg" v-model="filterTitle" :show-clean="true"
                                :placeholder="_('English name')" @keyup.native.enter="saveFilters"></va-input>
                            <va-input size="lg" v-model="filterTitlePashto" :show-clean="true"
                                :placeholder="_('Pashto name')" @keyup.native.enter="saveFilters"></va-input>
                            <va-input size="lg" v-model="filterTitleDari" :show-clean="true"
                                :placeholder="_('Dari name')" @keyup.native.enter="saveFilters"></va-input>
                        </div>
                        <br>
                        <!-- <div>
                            <va-checkbox v-model="showInSidebar" style="margin-left: 10px">Show in Sidebar</va-checkbox>
                        </div> -->
                    </div>
                </va-modal>
            </div>
            <div style="display:flex; flex-direction:row;">
                <!-- <va-button style="margin-right: 10px" @click.native="clearType" v-if="$store.getters.isSearching && className == 'Files'">
                    <va-icon type="times"></va-icon>
                </va-button> -->
                <va-dropdown v-if="className == 'Files'" :click-close="false" style="margin-right: 10px"
                    ref="fileTypes">
                    <div slot="trigger">
                        <va-button>
                            <va-icon type="file"></va-icon>
                        </va-button>
                    </div>
                    <li v-for="(cat, index) in fileCats"><a @click="filterFilesBasedOn(cat)">{{ cat.label }}</a></li>
                </va-dropdown>

                <va-tooltip v-if="isSubmissions" :content="_('Compact Rows')" placement="top" trigger="hover">
                    <va-button :type="paddingType == 'small' ? 'default' : 'subtle'"
                        @click.native="toggleRowsPadding()">
                        <va-icon style="zoom:.7;" type="bars"></va-icon>
                    </va-button>
                </va-tooltip>

                <to-excel-local @downloadCSV="prepareCSVFileForDownload" :key="csvKey" :data="json_data"
                    ref="CSVGenerator" :name="g_getLabel(viewedForm) + '.xls'"
                    v-if="section == 'survey' && getSubmissionsCount != 0 && user && user.get('roles') && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('survey-editor'))">
                    <va-tooltip trigger="hover"
                        :content="_('Download all submissions as .xls file [ While openning file accept all warnings ]')"
                        :placement="'top'">
                        <va-button :loading="isDownloading" style="margin-left: 5px; margin-right: 5px;">
                            <va-icon type="download"></va-icon>
                        </va-button>
                    </va-tooltip>
                </to-excel-local>

                <!-- <to-csv :key="csvKey" style="margin-right: 5px"
                    v-if="section == 'survey' && getSubmissionsCount != 0 && user && user.get('roles') && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('survey-editor'))"
                    @downloadCSV="prepareCSVFileForDownload" :data="json_data" ref="CSVGenerator"
                    :name="g_getLabel(viewedForm) + '.csv'">
                    <va-tooltip trigger="hover" :content="_('Download all submissions as .csv file')"
                        :placement="'top'">
                        <va-button :loading="isDownloading" style="margin-left: 5px">
                            <va-icon type="download"></va-icon>
                        </va-button>
                    </va-tooltip>
                </to-csv> -->

                <va-input @change="search(1)" v-model="searchString" :placeholder="_('Search here')" icon="search"
                    showClean></va-input>
            </div>
        </div>

        <va-row :gutter="12" style="clear: both; position: relative;">
            <div>
                <va-row :gutter="12">
                    <va-column :lg="12" :md="12" :sm="12">
                        <va-dropdown v-if="isSubmissions"
                            :class="{showColDropDownRtl: getSystemLanguage != 'english', showColDropDownLtr: getSystemLanguage == 'english'}">

                            <div slot="trigger">
                                <va-button type="primary">
                                    <va-icon type="ellipsis-h"></va-icon>
                                </va-button>
                            </div>
                            <div style="zoom:1.25; min-width: 300px ;padding:10px;margin:0;">
                                <va-checkbox-group class="submission_col_checkbox" v-model="showColumns"
                                    :vertical="true">
                                    <va-checkbox style="max-width: 300px;
                                        overflow: hidden;
                                        text-overflow: ellipsis;" v-for="(f, index) in  fields" :checked="f.show"
                                        :label="f.key">{{getTableHead(f)}}</va-checkbox>
                                </va-checkbox-group>
                            </div>

                        </va-dropdown>

                        <!-- /////////////////////////////////////           submission table              --------------- /////// -->
                        <va-table hover fullWidth class="datatable">
                            <table :dir="getDirectionStatus" style="table-layout:fixed;">
                                <thead>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english'}" style="overflow:hidden"
                                        v-for="(f, index) in  fields" v-if="f.show">
                                        {{getTableHead(f) }}
                                    </th>
                                </thead>
                                <tbody>
                                    <tr v-for="(record, index) in records"
                                        v-if="(allRecordsCount !== 0 && record.get('createdBy')) || (!isSubmissions && record.get('category'))"
                                        class="entry_row"
                                        @click="navigateToSubmission($route.params.scope + '/' + $route.params.category + '/' + viewedForm.get('class_name').slice(5) + '/list/' + record.id, $route.meta.isPublicView)">

                                        <!-- submissions -->
                                        <td :class="{rtlTd: getSystemLanguage != 'english', smallPadding: paddingType == 'small', mediumPadding: paddingType == 'medium', largePadding: paddingType == 'large'}"
                                            v-for="(f, index) in  fields" v-if="f.show && isSubmissions"
                                            style="position:relative">
                                            <span
                                                v-if="!$route.meta.isPublicView && f.key==fields.reduce((i,itm,ind)=> itm.show ? itm : i,-1).key && record.get('status') == 'pending' && viewedForm.submissionApprovers.length != 0"
                                                :class="{labelRtl: getSystemLanguage != 'english', labelLtr: getSystemLanguage == 'english'}">
                                                {{ _('PENDING') }}</span>

                                            <span
                                                v-if="!$route.meta.isPublicView && f.key==fields.reduce((i,itm,ind)=> itm.show ? itm : i,-1).key && record.get('status') == 'approved' && viewedForm.submissionApprovers.length != 0"
                                                style="background: #c9ffc1;"
                                                :class="{labelRtl: getSystemLanguage != 'english', labelLtr: getSystemLanguage == 'english'}">{{
                                                _('APPROVED') }}</span>
                                            <span
                                                v-if="!$route.meta.isPublicView && f.key==fields.reduce((i,itm,ind)=> itm.show ? itm : i,-1).key && record.get('status') == 'rejected' && viewedForm.submissionApprovers.length != 0"
                                                style="background: #ffd4d4;"
                                                :class="{labelRtl: getSystemLanguage != 'english', labelLtr: getSystemLanguage == 'english'}">{{
                                                _('REJECTED') }}</span>

                                            {{ getValue(record.get(f.key), f) }} </td>

                                        <!-- other sections (articles, files , maps) -->
                                        <td v-if="!isSubmissions"
                                            :class="{rtlTd: getSystemLanguage != 'english', fixed_td: true}">

                                            <va-icon v-if="section == 'file'" size="2em"
                                                :type="'file-'+getFileMainType(record.get('attachments'))"
                                                :color="getIconColor(getFileMainType(record.get('attachments')))"
                                                style="margin-right:10px;"></va-icon>

                                            <a style="cursor:pointer"
                                                @click="navigate({name: section + 'Preview', params: {id: record.id, category: $route.params.category, scope: $route.params.scope}}   )">
                                                {{ g_getLabel(record) }}</a>
                                        </td>

                                        <td v-if="!isSubmissions"
                                            :class="{rtlTd: getSystemLanguage != 'english', fixed_td: true}">
                                            <span v-if="record.get('createdBy')!=null">
                                                {{record.get('createdBy').get('name')}}
                                            </span>
                                        </td>

                                        <td v-if="!isSubmissions"
                                            :class="{rtlTd: getSystemLanguage != 'english', fixed_td: true}">
                                            {{new Date(record.get('createdAt')).getFullYear() + '-' + parseInt(1 +
                                            new
                                            Date(record.get('createdAt')).getMonth())+ '-' + new
                                            Date(record.get('createdAt')).getDate()}}

                                        </td>
                                        <td v-if="!isSubmissions" :class="{rtlTd: getSystemLanguage != 'english'}">
                                            <va-lozenge v-if="record.get('status') == 'approved'" type="success" bold>
                                                {{ _(record.get('status')) }}</va-lozenge>
                                            <va-lozenge v-else-if="record.get('status') == 'pending'" type="primary"
                                                bold>
                                                {{ _(record.get('status')) }}
                                            </va-lozenge>
                                            <va-lozenge v-else-if="record.get('status') == 'rejected'" type="danger"
                                                bold>
                                                {{ _(record.get('status')) }}
                                            </va-lozenge>
                                        </td>
                                        <td v-if="!isSubmissions && user && !user.get('roles').includes('guest')"
                                            :class="{rtlTd: getSystemLanguage != 'english'}">
                                            <va-tooltip
                                                v-if="record.get('approvalBy') && record.get('status') != 'pending'"
                                                :content="record.get('approvalBy').get('name')" trigger="hover"
                                                placement="top">
                                                <img v-if="record.get('approvalBy') && (record.get('approvalBy').get('profilePic') != '' || record.get('approvalBy').get('profilePic') != null)"
                                                    width="30px" height="30px"
                                                    style="display:inline-block;  border-radius: 100px; border:1px solid #fff;"
                                                    :src="record.get('approvalBy').get('profilePic').replace('https://parse.nepa.gov.af/parse/files/nepa/', 'https://parse.nepa.gov.af/parse/files/nepa/thumbnail_')" />
                                            </va-tooltip>
                                            <!-- <va-lozenge v-else-if="record.get('status') == 'pending'" type="primary"
                                                bold>
                                                {{ _('pending') }}</va-lozenge> -->
                                        </td>
                                        <td v-if="!isSubmissions"
                                            :class="{rtlTd: getSystemLanguage != 'english', fixed_td: true}">
                                            <div style="display: flex; justify-content: space-around; width: 70px">

                                                <va-tooltip
                                                    v-if="(user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes(section + '-editor') || user.get('roles').includes(section + '-editor')|| user.get('roles').includes(section + '-approver') || (user.get('roles').includes(section + '-creator') && record.get('createdBy').id == user.id)) && record.get('status') == 'pending'"
                                                    :content="_('edit')" trigger="hover" placement="top">
                                                    <va-icon class="actions_btn"
                                                        @click.native="navigate('/' + section + 's/' + $route.params.scope + '/' + $route.params.category + '/edit/' + record.id)"
                                                        type="edit" color="gray"></va-icon>
                                                </va-tooltip>

                                                <va-tooltip :content="_('preview')" trigger="hover" placement="top">
                                                    <va-icon class="actions_btn" type="eye" color="gray"
                                                        @click.native="navigate({name: section + 'Preview', params: {id: record.id, category: $route.params.category, scope: $route.params.scope}})">
                                                    </va-icon>
                                                </va-tooltip>

                                                <va-tooltip
                                                    v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes(section + '-editor')"
                                                    :content="_('delete')" trigger="hover" placement="top">
                                                    <va-icon class="actions_btn" type="trash-alt" color="gray"
                                                        @click.native="deleteObject(record)"></va-icon>
                                                </va-tooltip>

                                                <va-tooltip
                                                    v-if="section == 'file' && !user.get('roles').includes('guest')"
                                                    :content="_('download')" trigger="hover" placement="top">
                                                    <va-icon class="actions_btn" type="download" color="gray"
                                                        @click.native="sendEmail({to: user.get('username'), subject: section.charAt(0).toUpperCase() + section.slice(1) + ': ' + g_getLabel(record) + ', attachment download', text: 'You can download the requested attachment from this link: ' + record.get('attachments')})">
                                                    </va-icon>
                                                </va-tooltip>
                                            </div>
                                        </td>

                                    </tr>

                                    <tr v-if="allRecordsCount == 0">
                                        <td :colspan="numberOfCols" style="text-align: center">
                                            {{ _(getEmptyText)
                                            }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </va-table>
                    </va-column>
                </va-row>

                <va-row :gutter="0">

                    <va-column :lg="12" :sm="12">
                        <div style="display: flex">
                            <!-- <v-page :key="$route.path" :class="{no_click: getSubmissionsCount == 0}"
                                :total-row="getSubmissionsCount" @page-change="paginate"
                                :pageSizeMenu="[10, 20, 50, 100]">
                            </v-page> -->

                            <my-page :key="$route.path" :class="{no_click: getSubmissionsCount == 0}"
                                :total-row="getSubmissionsCount" @page-change="paginate"
                                :pageSizeMenu="[10, 20, 50, 100]">
                            </my-page>

                            <va-button style="margin-left: 10px" @click.native="paginate({pageNumber: page})">
                                <va-icon type="sync-alt"></va-icon>
                            </va-button>
                        </div>
                    </va-column>

                </va-row>
            </div>

        </va-row>

    </div>
    </div>

</template>

<script>
    import Parse from "@/main.js"
    import { mapGetters, mapActions } from "vuex";
    import { store } from "../store/index.js";
    import moment from 'moment';
    import momentJalali from 'jalali-moment';
    import UserSelection from './UserSelection.vue';
    import PageNumberSelection from './PageNumberSelection.vue';
    import ToCSV from '../components/ToCSV.vue'
    import MyPage from '../components/Page.vue'
    import JsonExcel from 'vue-json-excel'
    import JsonExcelLocal from '../components/JsonExcel.vue'

    export default {

        props: ['isSubmissions'],

        components: {
            UserSelection,
            PageNumberSelection,
            'to-csv': ToCSV,
            'my-page': MyPage,
            'to-excel': JsonExcel,
            'to-excel-local': JsonExcelLocal
        },
        data() {
            return {
                json_data: [{}],
                readonly: true,
                hourRangeMin: 0,
                hourRangeMax: 23,
                minuteRangeMin: 0,
                minuteRangeMax: 59,
                secondRangeMin: 0,
                secondRangeMax: 59,

                filterValue: '',
                filterValueArr: [],
                filterCondition: '',
                filterFromDate: '',
                filterToDate: '',
                dateRangeFilterLabel: '',
                isExcluded: false,

                dropDown: 'first',
                filters: [],
                filterFields: [],
                filterTitle: '',
                filterTitlePashto: '',
                filterTitleDari: '',

                currentFilterField: {},
                searchString: '',
                errorMessage: '',
                searchedArticlesCount: [],


                filterUsers: [],
                filterApproverUsers: [],

                className: '',
                parentRoute: '',
                section: '',
                viewedFilterObj: null,

                currentCategory: null,
                fileCats: [],
                searchCount: null,

                //submission
                records: [],
                page: 1,
                allRecordsCount: 0,
                searchedSubmissionsCount: null,
                paddingType: 'large',
                showColumns: [],
                fields: [],
                formLanguages: [],
                viewedForm: { get: () => '' },

                theClassName: '',
                filterErrorMessage: '',
                isSearching: false,
                searchPage: 1,
                showInSidebar: false,

                // category
                category: null,
                currentDepartment: null,
                isDownloading: false,
                csvKey: ''
            }
        },

        computed: {
            ...mapGetters(['user', 'getSystemLanguage', 'getCurrentCategory', 'getSearchedUsers', 'getDirectionStatus', 'getCurrentDepartment', 'getThisTableRecordPerPage']),

            getCategory() {
                return this.category || this.getCurrentCategory
            },

            getRoles() {
                if (this.user.get('roles').includes('manager') || this.user.get('roles').includes(this.section + '-editor') || this.user.get('roles').includes('submission-approver')) {
                    if (this.section == 'survey') {
                        return ['submitter', 'survey-editor', 'manager']
                    } else {
                        return [this.section + '-editor', 'manager', this.section + '-creator']
                    }
                } else if (this.user.get('roles').includes('admin')) {
                    if (this.section == 'survey') {
                        return ['admin', 'manager', 'submitter', 'survey-editor']
                    } else {
                        return ['admin', 'manager', this.section + '-editor', this.section + '-creator']
                    }
                }
            },

            getApprovalByRoles() {
                if (this.user.get('roles').includes('manager') || this.user.get('roles').includes(this.section + '-editor') || this.user.get('roles').includes('submission-approver')) {
                    if (this.section == 'survey') {
                        return ['survey-editor', 'manager', 'submission-approver']
                    } else {
                        return [this.section + '-editor', 'manager', this.section + '-approver']
                    }

                } else if (this.user.get('roles').includes('admin')) {
                    if (this.section == 'survey') {
                        return ['admin', 'manager', 'submission-approver', 'survey-editor']
                    } else {
                        return ['admin', 'manager', this.section + '-approver', this.section + '-editor']
                    }
                }
            },

            getEmptyText() {
                if (this.isSubmissions) return 'No submissions available'
                else return 'No ' + this.section + ' available'
            },

            //  submision
            numberOfCols() {
                return this.showColumns.length
            },


            getSubmissionsCount() {

                if (this.getSearchError == '' && this.isSearchingContent) {
                    return this.getSearchedResult.length
                }
                else {
                    return this.allRecordsCount

                }
            },
        },

        watch: {

            getThisTableRecordPerPage(val) {
            },

            showColumns(val) {
                let newFields = this.fields.map(f => {
                    return {
                        ...f,
                        show: val.some(v => v == f.key)
                    }
                });
                this.fields = newFields;
            },

            async '$route'(to, from) {
                this.$store.commit('setLoading', true)
                this.filters = []
                this.viewedFilterObj = null

                if (this.$route.query.filterId) {
                    this.fetchFilter(this.$route.query.filterId)
                        .then(res => {
                            this.search(1)
                        })
                } else {
                    this.records = []
                    this.allRecordsCount = 0
                    await this.fetchings()
                }
            },
        },


        methods: {
            ...mapActions(['getUsers', 'setSystemLanguage', 'setSearchedResult', 'setSearchError', 'fetchSidebarReports']),

            async prepareCSVFileForDownload() {
                if (this.viewedForm && this.viewedForm.get('layout') && this.theClassName && this.isDownloading == false) {
                    this.isDownloading = true
                    let q = new Parse.Query(this.theClassName)
                    q.include('approvalBy')
                    q.include('createdBy')
                    q.include('category')
                    q.include('department')
                    q.include('form')
                    var allSubmissions = await q.find()
                    var modified = [];
                    if (allSubmissions) {
                        for (let i = 0; i < allSubmissions.length; i++) {
                            const submission = allSubmissions[i];
                            if (submission) {
                                var rowInCSVFile = {
                                    'objectId': submission.id,
                                    'class Name': submission.className,
                                    'createdBy': submission.get('createdBy') != null ? submission.get('createdBy').get('name') : 'N/A',
                                    'approvalBy': submission.get('approvalBy') != null ? submission.get('approvalBy').get('name') : 'N/A',
                                    'category': submission.get('category') != null ? submission.get('category').get('label_english') : 'N/A',
                                    'department': submission.get('department') != null ? submission.get('department').get('label_english') : 'N/A',
                                    'form': submission.get('form') != null ? submission.get('form').get('label_english') : 'N/A',
                                    'status': this.viewedForm.get('submission_require_approval') ? submission.get('status') : '',
                                    'createdAt': submission.get('createdAt'),
                                    'updatedAt': submission.get('updatedAt'),
                                    'submission_language': submission.get('submission_language'),
                                };
                                for (let j = 0; j < this.viewedForm.get('layout').length; j++) {
                                    const field = this.viewedForm.get('layout')[j];
                                    var columnLabel = this.getTableHead({ label: { english: field.englishLabel, pashto: field.pashtoLabel, dari: field.dariLabel } })
                                    if (field && field.type != 'heading' && field.type != 'description') {
                                        if (field.type == 'date') {
                                            if (submission.get(field.fieldDatabaseName)) {
                                                if (field.isTime) {
                                                    rowInCSVFile[columnLabel] = moment.utc(submission.get(field.fieldDatabaseName) * 1000).format('HH:mm:ss')
                                                } else {
                                                    if (field.isHijri) {
                                                        var date = new Date(submission.get(field.fieldDatabaseName))
                                                        var stringDate = date.getFullYear() + '/' + parseInt(1 + date.getMonth()) + '/' + date.getDate()
                                                        rowInCSVFile[columnLabel] = momentJalali(stringDate, 'YYYY/MM/DD').locale('fa').format('YYYY-MM-DD');
                                                    } else {
                                                        rowInCSVFile[columnLabel] = submission.get(field.fieldDatabaseName)
                                                    }
                                                }
                                            }

                                        } else if (field.type == 'single-geolocation') {
                                            rowInCSVFile['latitude'] = submission.get('latitude')
                                            rowInCSVFile['longitude'] = submission.get('longitude')
                                        } else if (field.type == 'multiple-geolocation') {
                                            if (submission.get(field.fieldDatabaseName)) {
                                                var geos = [];
                                                for (let k = 0; k < submission.get(field.fieldDatabaseName).length; k++) {
                                                    const position = submission.get(field.fieldDatabaseName)[k];
                                                    if (position && position.position) {
                                                        geos.push(position.position.lat)
                                                        geos.push(position.position.lng)
                                                    }
                                                }
                                                rowInCSVFile[columnLabel] = geos.join(', ')
                                            }
                                        } else if ((field.type == 'attachment' && field.multiple) || (field.type == 'select' && field.multiple) || field.type == 'multiple-option') {
                                            if (submission.get(field.fieldDatabaseName)) {
                                                rowInCSVFile[columnLabel] = submission.get(field.fieldDatabaseName).join(', ')
                                            }
                                        } else {
                                            rowInCSVFile[columnLabel] = submission.get(field.fieldDatabaseName)

                                        }
                                    }
                                }
                                modified.push(rowInCSVFile);
                            }
                        }
                    }

                    if (this.$refs && this.$refs.CSVGenerator) {
                        this.json_data = modified == null ? [] : modified
                        this.csvKey = Date.now().toString()
                        setTimeout(() => {
                            this.$refs.CSVGenerator.generate()
                            this.$notify({
                                group: 'foo',
                                text: this._('Submissions was downloaded as .csv file'),
                                duration: 4000,
                                position: 'top left',
                                type: 'success'
                            });
                        }, 2000)
                    }
                    this.isDownloading = false

                }
            },

            backToFields() {
                setTimeout(() => { this.dropDown = 'first'; this.filterValue = ''; this.filterCondition = '' }, 50)
            },

            navigateToSubmission(route, isPublicView) {
                if (this.isSubmissions)
                    if (isPublicView) {
                        this.$router.push('/surveys/public/' + route)
                    } else {
                        this.$router.push('/surveys/' + route)
                    }
            },

            toggleRowsPadding() {
                this.paddingType = this.paddingType == 'small' ? 'large' : 'small';
            },

            getIconColor(fileType) {
                switch (fileType) {
                    case 'video': return 'darkorange'
                    case 'audio': return 'darkgray'
                    case 'image': return '#8bc'
                    case 'pdf': return 'darkred'
                    case 'archive': return '#b8c'
                    case 'alt': return 'darkcyan'
                }
            },

            getFileMainType(filename) {

                switch (filename.substring(filename.search(/(\.)(?!.*\.)/) + 1)) {
                    case 'mp4': return 'video'
                    case 'mpg': return 'video'
                    case 'avi': return 'video'
                    case 'mpeg': return 'video'
                    case 'mkv': return 'video'
                    case '3gp': return 'video'
                    case 'm4a': return 'video'
                    case 'wmv': return 'video'
                    case 'asf': return 'video'
                    case 'm4a': return 'video'


                    case 'wav': return 'audio'
                    case 'mp3': return 'audio'
                    case 'midi': return 'audio'
                    case 'jpg': return 'image'
                    case 'jpeg': return 'image'
                    case 'bmp': return 'image'
                    case 'png': return 'image'
                    case 'tiff': return 'image'
                    case 'gif': return 'image'
                    case 'ico': return 'image'
                    case 'pdf': return 'pdf'
                    case 'zip': return 'archive'
                }

                return 'alt'
            },


            async deleteObject(object) {
                this.g_deleteObject(object)
                    .then(async result => {
                        if (result) {
                            if (object.className == 'Article' || object.className == 'File' || object.className == 'Map') {
                                this.$store.commit('setLoading', true)
                                await this.fetchRecords(this.page)
                                await this.fetchRecordsCount()
                            } else this.$router.go(-1)
                        }
                    }).catch(e => {

                    })
            },


            getTableHead(field) {

                let languages = ["english", "pashto", "dari"];
                if (this.isSubmissions) {
                    languages = this.viewedForm.get('form_languages')
                }
                if (this.getSystemLanguage == 'dari') {
                    if (languages.includes('dari')) return field.label.dari
                    else {
                        if (languages[0] == 'pashto') return field.label.pashto
                        else return field.label.english
                    }
                }
                if (this.getSystemLanguage == 'pashto') {
                    if (languages.includes('pashto')) return field.label.pashto
                    else {
                        if (languages[0] == 'dari') return field.label.dari
                        else return field.label.english
                    }
                } else {
                    if (languages.includes('english')) return field.label.english
                    else {
                        if (languages[0] == 'pashto') return field.label.pashto
                        else return field.label.dari
                    }
                }
            },

            getValue(record, theField) {
                if (record instanceof Date) {
                    if (theField.type == 'date') {
                        if (theField.field.isHijri) {
                            if (record) {
                                var date = new Date(record)
                                var stringDate = date.getFullYear() + '/' + parseInt(1 + date.getMonth()) + '/' + date.getDate()
                                return momentJalali(stringDate, 'YYYY/MM/DD').locale('fa').format('YYYY-MM-DD');
                            }
                        } else {
                            return new Date(record).getFullYear() +
                                '-' + (parseInt(new Date(record).getMonth()) + parseInt(1)) + '-' +
                                new
                                    Date(record).getDate()
                        }
                    }
                } else if (theField.type == 'date') {
                    if (theField.field.isTime && record && theField.field.isTime) {
                        return moment.utc(record * 1000).format('HH:mm:ss')
                    } else return ''
                } else if (theField.type == 'createdBy') {
                    return record != null ? record.get('name') : 'n/a'
                } else if (theField.type == 'select' || theField.type == 'multiple-option' || theField.type ==
                    'single-option') {
                    if (!Array.isArray(record)) record = [record]

                    var ret = []
                    for (var f in this.fields) {
                        if (this.fields[f].key == theField.key) {
                            for (var d in this.fields[f].options) {
                                for (const key in record) {
                                    if (record[key] == this.fields[f].options[d].value) {
                                        if (this.getSystemLanguage == 'dari') {
                                            if (this.formLanguages.includes('dari')) ret.push(this.fields[f].options[d].dariLabel)
                                            else {
                                                if (this.formLanguages[0] == 'pashto') ret.push(this.fields[f].options[
                                                    d].pashtoLabel)
                                                else ret.push(this.fields[f].options[d].englishLabel)
                                            }
                                        }

                                        if (this.getSystemLanguage == 'pashto') {
                                            if (this.formLanguages.includes('pashto')) ret.push(this.fields[f].options[
                                                d].pashtoLabel)
                                            else {
                                                if (this.formLanguages[0] == 'dari') ret.push(this.fields[f].options[d].dariLabel)
                                                else ret.push(this.fields[f].options[d].englishLabel)
                                            }


                                        } else {
                                            if (this.formLanguages.includes('english')) ret.push(this.fields[f].options[d].englishLabel)
                                            else {
                                                if (this.formLanguages[0] == 'pashto') ret.push(this.fields[f].options[
                                                    d].pashtoLabel)
                                                else ret.push(this.fields[f].options[d].dariLabel)
                                            }
                                        }
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    return ret.join(', ')
                } else if (theField.type == 'checkbox') {
                    if (this.getSystemLanguage == 'dari') return record ? 'بلی' : 'نخیر'
                    if (this.getSystemLanguage == 'pashto') return record ? 'هو' : 'نه'
                    else return record ? 'Yes' : 'No'
                } else {
                    return record
                }
            },


            async paginate(page) {
                this.$store.commit('setLoading', true)
                if (this.isSearching) {

                    // this.searchPage++

                    await this.search(page.pageNumber)
                }
                else {

                    this.page = page.pageNumber
                    await this.fetchRecords(page.pageNumber)
                    await this.fetchRecordsCount()
                }
            },

            navigate(to) {
                this.$router.push(to);
            },

            getOptionLabelForView(option) {
                if (this.getSystemLanguage == 'dari') {
                    if (this.formLanguages.includes('dari')) return option.dariLabel
                    else {
                        if (this.formLanguages[0] == 'pashto') return option.pashtoLabel
                        else return option.englishLabel
                    }
                } else if (this.getSystemLanguage == 'pashto') {
                    if (this.formLanguages.includes('pashto')) return option.pashtoLabel
                    else {
                        if (this.formLanguages[0] == 'dari') return option.dariLabel
                        else return option.englishLabel
                    }
                } else {
                    if (this.formLanguages.includes('english')) return option.englishLabel
                    else {
                        if (this.formLanguages[0] == 'pashto') return option.pashtoLabel
                        else return option.dariLabel
                    }
                }
            },

            getLabel(names) {
                if (names != null) {
                    if (this.section == 'survey') {
                        if (this.getSystemLanguage == 'dari') {
                            if (this.formLanguages.includes('dari') && names.dari != '') return names.dari
                            else {
                                if (this.formLanguages[0] == 'pashto' && names.pashto != '') return names.pashto
                                else return names.english
                            }
                        }
                        if (this.getSystemLanguage == 'pashto') {
                            if (this.formLanguages.includes('pashto') && names.pashto != '') return names.pashto
                            else {
                                if (this.formLanguages[0] == 'dari' && names.dari != '') return names.dari
                                else return names.english
                            }
                        } else {
                            if (this.formLanguages.includes('english') && names.english != '') return names.english
                            else {
                                if (this.formLanguages[0] == 'pashto' && names.pashto != '') return names.pashto
                                else return names.dari
                            }// if (this.getSystemLanguage == 'dari' && names.dari != '') return names.dari
                            // else if (this.getSystemLanguage == 'pashto' && names.pashto != '') return names.pashto
                            // else return names.english
                        }
                    } else {
                        if (this.getSystemLanguage == 'dari' && names.dari != '') return names.dari
                        else if (this.getSystemLanguage == 'pashto' && names.pashto != '') return names.pashto
                        else return names.english
                    }
                }


                // if (this.getSystemLanguage == 'dari') {
                //     if (name.dari != '') return name.dari
                //     else {
                //         if (this.getSystemLanguage == 'pashto') return name.pashto
                //         else return name.english
                //     }
                // }
                // if (this.getSystemLanguage == 'pashto') {
                //     if (this.getSystemLanguage == 'pashto') return name.pashto
                //     else {
                //         if (this.getSystemLanguage == 'dari') return name.dari
                //         else return name.english
                //     }
                // } else {
                //     if (this.getSystemLanguage == 'english' && name.english != '') return name.english
                //     else {
                //         if (name.pashto != '') return name.pashto
                //         else return name.dari
                //     }
                // }
                // if (this.getSystemLanguage == 'dari' && names.dari != '') return names.dari
                // else if (this.getSystemLanguage == 'pashto' && names.pashto != '') return names.pashto
                // else return names.english
            },

            filterExists(field) {
                if (this.filters.length == 0) return false;
                return this.filters.some(filter => filter.column == field.key)
            },

            deleteFilter() {
                this.g_deleteObject(this.viewedFilterObj)
                    .then(res => {
                        this.viewedFilterObj = null
                        // this.fetchSidebarReports()
                        this.$router.replace('/' + this.$route.matched[0].name + '/' + this.$route.params.scope + '/' + this.$route.params.category)
                    })
            },

            saveFilterModal() {
                if (this.viewedFilterObj) {
                    if (this.filters.length == 0) {
                        var self = this
                        self.VaModal.confirm({
                            title: self._('Alert'),
                            message: self._('Saving with no filter actually deletes the entire filter'),
                            type: 'warning',
                            onConfirm() {
                                self.g_deleteObject(self.viewedFilterObj)
                                    .then(res => {
                                        self.viewedFilterObj = null
                                        self.$router.replace('/' + self.$route.matched[0].name + '/' + self.$route.params.scope + '/' + self.$route.params.category)

                                    })
                            }
                        })
                    } else {
                        this.$refs.filtersModal.open()
                    }
                } else {
                    if (this.filters.length == 0) {
                        this.$notify({
                            group: 'foo',
                            text: this._('At least one filter is required to save the filter'),
                            duration: 4000,
                            position: 'top left',
                            type: 'info'
                        });

                    } else {
                        this.$refs.filtersModal.open()
                    }
                }
            },



            saveFilters() {
                if (this.filterTitle == '') {
                    this.$notify({
                        group: 'foo',
                        text: this._('English name is required'),
                        duration: 4000,
                        position: 'top left',
                        type: 'error'
                    });

                } else {
                    if (this.viewedFilterObj) {
                        this.viewedFilterObj.set('label_english', this.filterTitle)
                        this.viewedFilterObj.set('label_pashto', this.filterTitlePashto)
                        this.viewedFilterObj.set('label_dari', this.filterTitleDari)
                        this.viewedFilterObj.set('filters', this.filters)
                        this.viewedFilterObj.set('show_in_sidebar', this.showInSidebar)

                        this.viewedFilterObj.save()
                            .then(async updated => {
                                this.viewedFilterObj = updated
                                // await this.fetchSidebarReports()
                                this.$notify({
                                    group: 'foo',
                                    text: this._('Filter was updated'),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'success'
                                });
                                await this.g_newActivity({
                                    label_english: updated.get('label_english'),
                                    label_pashto: updated.get('label_pashto'),
                                    label_dari: updated.get('label_dari'),
                                    type: this.$route.matched[0].name.substring(0, this.$route.matched[0].name.length - 1),
                                    action: 'editFilter',
                                    url: this.$route.path + '?filterId=' + updated.id,
                                    createdBy: this.user.id,
                                    to: null,
                                    category: this.getCategory,
                                    department: this.currentDepartment,
                                    class: 'Filter',
                                    reference_id: this.section == 'survey' ? this.viewedForm.id : null
                                })
                            }).catch(e => {
                                this.$notify({
                                    group: 'foo',
                                    title: this._('System Error'),
                                    text: this._('An error was encountered while updating filter'),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'error'
                                });
                            })

                    } else {
                        let Filter = new Parse.Object.extend('Filter')
                        let newFilter = new Filter()
                        newFilter.save({
                            label_english: this.filterTitle,
                            label_pashto: this.filterTitlePashto,
                            label_dari: this.filterTitleDari,
                            filters: this.filters,
                            type: this.section,
                            show_in_sidebar: this.showInSidebar,
                            createdBy: this.user,
                            class: this.theClassName,
                            category: this.getCategory,
                            department_slug: this.$route.params.scope,
                            department: this.currentDepartment,
                            form: this.section == 'survey' ? this.viewedForm : null
                        }).then(async insertedFilter => {

                            this.viewedFilterObj = insertedFilter
                            this.$notify({
                                group: 'foo',
                                text: this._('Filter was saved'),
                                duration: 4000,
                                position: 'top left',
                                type: 'success'
                            });
                            // this.$router.replace({ name: this.$route.matched[0].name, params: { scope: this.$route.params.scope, category: this.$route.params.category }, query: { filterId: insertedFilter.id } })
                            if (this.isSubmissions) this.$router.replace('/' + this.$route.matched[0].name + '/' + this.$route.params.scope + '/' + this.$route.params.category + '/' + this.$route.params.form_slug + '/list?filterId=' + insertedFilter.id)
                            else this.$router.replace('/' + this.$route.matched[0].name + '/' + this.$route.params.scope + '/' + this.$route.params.category + '?filterId=' + insertedFilter.id)
                            await insertedFilter.save({ url: this.$route.path + '?filterId=' + insertedFilter.id })
                            // this.fetchSidebarReports()

                            this.g_newActivity({
                                label_english: insertedFilter.get('label_english'),
                                label_pashto: insertedFilter.get('label_pashto'),
                                label_dari: insertedFilter.get('label_dari'),
                                type: this.$route.matched[0].name.substring(0, this.$route.matched[0].name.length - 1),
                                action: 'createFilter',
                                url: this.$route.path + '?filterId=' + insertedFilter.id,
                                createdBy: this.user.id,
                                to: null,
                                category: this.getCategory,
                                department: this.currentDepartment,
                                class: 'Filter',
                                reference_id: this.section == 'survey' ? this.viewedForm.id : null
                            })
                        }).catch(e => {
                            this.$notify({
                                group: 'foo',
                                title: this._('System Error'),
                                text: this._('An error was encountered while saving filter'),
                                duration: 4000,
                                position: 'top left',
                                type: 'error'
                            });
                        })
                    }

                }
                this.$refs.filtersModal.close()
            },

            getOptionLabel(field) {
                let ret = [];
                var newArr = []
                for (var f in this.currentFilterField.options) {
                    for (var d = 0; d < field.length; d++) {
                        if (this.currentFilterField.options[f].value == field[d]) {
                            // ret.push(this.currentFilterField.options[f].label);
                            if (this.getSystemLanguage == 'dari') {
                                if (this.formLanguages.includes('dari')) ret.push(this.currentFilterField.options[f].dariLabel)
                                else {
                                    if (this.formLanguages[0] == 'pashto') ret.push(this.currentFilterField.options[f].pashtoLabel)
                                    else ret.push(this.currentFilterField.options[f].englishLabel)
                                }
                            }
                            if (this.getSystemLanguage == 'pashto') {
                                if (this.formLanguages.includes('pashto')) ret.push(this.currentFilterField.options[f].pashtoLabel)
                                else {
                                    if (this.formLanguages[0] == 'dari') ret.push(this.currentFilterField.options[f].dariLabel)
                                    else ret.push(this.currentFilterField.options[f].englishLabel)
                                }
                            } else {
                                if (this.formLanguages.includes('english')) ret.push(this.currentFilterField.options[f].englishLabel)
                                else {
                                    if (this.formLanguages[0] == 'pashto') ret.push(this.currentFilterField.options[f].pashtoLabel)
                                    else ret.push(this.currentFilterField.options[f].dariLabel)
                                }
                            }
                        }
                    }
                }
                return ret;
            },

            createFilter() {

                var filterValue = ''
                if (this.currentFilterField.type == 'date') {
                    if (this.currentFilterField.field) {
                        if (this.currentFilterField.field.isTime) {
                            if (this.filterValue) {
                                var times = this.filterValue.split(':')
                                var hourToSeconds = parseInt(times[0]) * 60 * 60;
                                var minToSeconds = parseInt(times[1]) * 60;
                                var seconds = parseInt(times[2]);
                                var totalSeconds = hourToSeconds + minToSeconds + seconds;
                                filterValue = {
                                    valueToShow: moment.utc(totalSeconds * 1000).format('HH:mm:ss'),
                                    extra: totalSeconds
                                }
                            } else {
                                filterValue = {
                                    valueToShow: '',
                                    extra: 0
                                }
                            }
                        } else {
                            if (this.currentFilterField.field.isHijri) {
                                var from = this.filterFromDate !== '' ? new Date(this.filterFromDate).getFullYear() + '/' + parseInt(new Date(this.filterFromDate).getMonth() + parseInt(1)) + '/' + new Date(this.filterFromDate).getDate() : ''
                                var to = this.filterToDate !== '' ? new Date(this.filterToDate).getFullYear() + '/' + parseInt(new Date(this.filterToDate).getMonth() + parseInt(1)) + '/' + new Date(this.filterToDate).getDate() : ''
                                var miladiFrom = ''
                                var miladiTo = ''


                                if (from) {
                                    miladiFrom = momentJalali.from(from, 'fa', 'YYYY/MM/DD').format('YYYY/MM/DD');
                                }

                                if (to) {
                                    miladiTo = momentJalali.from(to, 'fa', 'YYYY/MM/DD').format('YYYY/MM/DD');
                                }


                                if (this.dateRangeFilterLabel != '') {
                                    filterValue = {
                                        valueToShow: this.dateRangeFilterLabel,
                                        extra: {
                                            from: miladiFrom,
                                            to: miladiTo
                                        }
                                    }
                                } else {
                                    let fromAndTo = '';

                                    if (from && to)
                                        fromAndTo = from + ' — ' + to;
                                    if (!from || !to)
                                        fromAndTo = from || to;

                                    filterValue = {
                                        valueToShow: fromAndTo,
                                        extra: {
                                            from: miladiFrom || '',
                                            to: miladiTo || ''
                                        }
                                    }
                                }

                            } else {
                                var from = this.filterFromDate !== '' ? new Date(this.filterFromDate).getFullYear() + '/' + parseInt(new Date(this.filterFromDate).getMonth() + parseInt(1)) + '/' + new Date(this.filterFromDate).getDate() : ''
                                var to = this.filterToDate !== '' ? new Date(this.filterToDate).getFullYear() + '/' + parseInt(new Date(this.filterToDate).getMonth() + parseInt(1)) + '/' + new Date(this.filterToDate).getDate() : ''

                                if (this.dateRangeFilterLabel != '') {
                                    filterValue = {
                                        valueToShow: this.dateRangeFilterLabel,
                                        extra: {
                                            from: from,
                                            to: to
                                        }
                                    }
                                } else {
                                    let fromAndTo = '';

                                    if (from && to)
                                        fromAndTo = from + ' — ' + to;
                                    if (!from || !to)
                                        fromAndTo = from || to;

                                    filterValue = {
                                        valueToShow: fromAndTo,
                                        extra: {
                                            from: from || '',
                                            to: to || ''
                                        }
                                    }
                                }
                            }
                        }
                    }
                } else if (this.currentFilterField.type == 'checkbox') {
                    filterValue = {
                        valueToShow: this.filterValue == 'true' ? this._('Yes') : this._('No'),
                        extra: this.filterValue == 'true' ? true : false
                    }

                    // created by
                } else if (this.currentFilterField.type == 'createdBy') {

                    var toShow = []
                    this.filterUsers.forEach(user => {
                        toShow.push(user.user.get('name'))
                    })

                    filterValue = {
                        valueToShow: toShow.join(', '),
                        extra: this.filterUsers
                    }

                } else if (this.currentFilterField.type == 'approvalBy') {

                    var toShow = []
                    this.filterApproverUsers.forEach(user => {
                        toShow.push(user.user.get('name'))
                    })

                    filterValue = {
                        valueToShow: toShow.join(', '),
                        extra: this.filterApproverUsers
                    }

                } else if (this.currentFilterField.type == 'multiple-option' || this.currentFilterField.type == 'select' || this.currentFilterField
                    .type == 'single-option') {
                    filterValue = {
                        valueToShow: Array.isArray(this.filterValue) ? this.getOptionLabel(this.filterValue).join(
                            ', ') : this.getOptionLabel([this.filterValue]).join(', '),
                        extra: this.filterValue
                    }
                } else if (this.currentFilterField.type == 'status') {
                    filterValue = {
                        valueToShow: this.filterValue.join(', '),
                        extra: this.filterValue
                    }
                } else if (this.currentFilterField.type == 'text' && (this.section == 'surveys' && this.currentFilterField.field.fieldType == 'number')) {
                    filterValue = { valueToShow: parseFloat(this.filterValue) }
                } else {
                    filterValue = { valueToShow: this.filterValue.trim() }
                }
                // end

                if (filterValue.valueToShow == '') {
                    this.$notify({
                        group: 'foo',
                        text: this._('Enter a value to create filter'),
                        duration: 4000,
                        position: 'top left',
                        type: 'warn'
                    });

                } else {
                    this.filters.push({
                        value: filterValue,
                        column: this.currentFilterField.key,
                        condition: this.filterCondition,
                        isExcluded: this.isExcluded,
                        type: this.currentFilterField.type,
                        field: this.currentFilterField.field
                    })
                    this.$refs.filterFieldsDropDown.close()
                    this.search(1)
                }
            },

            async search(pageNumber) {
                if (this.user && this.theClassName) {
                    var conditions = []
                    conditions.push(new Parse.Query(this.theClassName).notEqualTo('objectId', ''))

                    if (this.searchString == '' && this.filters.length == 0) {
                        await this.fetchRecords(this.page)
                        await this.fetchRecordsCount()
                        this.isSearching = false
                        return false
                    } else {
                        this.isSearching = true
                    }
                    conditions.push(new Parse.Query(this.theClassName).notEqualTo('objectId', ''))

                    if (this.user.get('roles').includes('guest')) {
                        if (this.isSubmissions) {
                            if (this.viewedForm.get('submission_require_approval'))
                                conditions.push(new Parse.Query(this.theClassName).equalTo('status', 'approved'))
                        } else {
                            conditions.push(new Parse.Query(this.theClassName).equalTo('shared_with', this.user))
                            conditions.push(new Parse.Query(this.theClassName).equalTo('status', 'approved'))
                        }
                    } else if (!this.user.get('roles').includes('guest')) {
                        conditions.push(new Parse.Query(this.theClassName).equalTo('category', this.getCategory))
                        // conditions.push(new Parse.Query(this.theClassName).equalTo('department', this.currentDepartment))
                    }

                    if (this.isSubmissions) {
                        if (this.$route.meta.isPublicView) {
                            // check survey of submission approval is on
                            if (this.viewedForm.get('submission_require_approval') && this.viewedForm.get('survey_submission_approvers') != null && this.viewedForm.get('survey_submission_approvers').length != 0) {
                                conditions.push(new Parse.Query(this.theClassName).equalTo('status', 'approved'));
                            }
                        } else {
                            if (!this.user.get('roles').includes('admin') && !this.user.get('roles').includes('manager') && !this.user.get('roles').includes('survey-editor')) {
                                var orTemp = [];
                                if (this.user.get('roles').includes('submitter'))
                                    orTemp.push(new Parse.Query(this.theClassName).equalTo('createdBy', this.user))

                                // for submission approvers
                                if (this.user.get('roles').includes('submission-approver')) {
                                    orTemp.push(new Parse.Query(this.theClassName).equalTo('approvalBy', this.user))

                                    if (this.viewedForm.get('submission_require_approval')) {
                                        if (this.viewedForm.get('survey_submission_approvers')) {
                                            for (let i = 0; i < this.viewedForm.get('survey_submission_approvers').length; i++) {
                                                const approver = this.viewedForm.get('survey_submission_approvers')[i];
                                                if (approver && approver.id == this.user.id) {
                                                    orTemp.push(new Parse.Query(this.theClassName).equalTo('status', 'pending'))
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }



                                if (this.user.get('roles').includes('survey-viewer') && this.viewedForm.get('submission_require_approval')) {
                                    orTemp.push(new Parse.Query(this.theClassName).equalTo('status', 'approved'))
                                }
                                if (orTemp.length == 0) orTemp.push(new Parse.Query(this.theClassName).notEqualTo('objectId', ''))
                                conditions.push(Parse.Query.or(...orTemp))
                            }
                        }
                    } else {
                        if (!this.user.get('roles').includes('admin') && !this.user.get('roles').includes('manager') && !this.user.get('roles').includes(this.section + '-editor')) {
                            var orTemp = [];
                            if (this.user.get('roles').includes(this.section + '-creator'))
                                orTemp.push(new Parse.Query(this.theClassName).equalTo('createdBy', this.user))

                            // for section approvers
                            if (this.user.get('roles').includes(this.section + '-approver')) {
                                orTemp.push(new Parse.Query(this.theClassName).equalTo('approvalBy', this.user))
                                orTemp.push(new Parse.Query(this.theClassName).equalTo('approvers', this.user))
                            }
                            if (this.user.get('roles').includes(this.section + '-viewer')) {
                                orTemp.push(new Parse.Query(this.theClassName).equalTo('status', 'approved'))
                            }
                            if (orTemp.length == 0) orTemp.push(new Parse.Query(this.theClassName).notEqualTo('objectId', ''))
                            conditions.push(Parse.Query.or(...orTemp))
                        }
                    }

                    if (this.filters.length > 0) {
                        this.filters.forEach(filter => {
                            // number field

                            if (filter.field.fieldType == 'number') {

                                if (!filter.isExcluded) {
                                    conditions.push(new Parse.Query(this.theClassName).equalTo(filter.column, filter.value.valueToShow))
                                }
                                else {
                                    conditions.push(new Parse.Query(this.theClassName).notEqualTo(filter.column, filter.value.valueToShow))
                                }
                            }
                            // contains
                            else if (filter.condition == 'contains') {

                                let regex
                                if (!filter.isExcluded)
                                    regex = new RegExp(`^.*${filter.value.valueToShow}.*`, "i");
                                else
                                    regex = new RegExp(`^(?!.*${filter.value.valueToShow}.*)`, "i");

                                if (this.isSubmissions) {
                                    conditions.push(new Parse.Query(this.theClassName).matches(filter.column, regex))
                                } else {
                                    let english = new Parse.Query(this.theClassName).matches(filter.column + '_english', regex)
                                    let pashto = new Parse.Query(this.theClassName).matches(filter.column + '_pashto', regex)
                                    let dari = new Parse.Query(this.theClassName).matches(filter.column + '_dari', regex)
                                    conditions.push(Parse.Query.or(english, pashto, dari))
                                }

                            } else if (filter.type == 'date' && filter.field && filter.field.isTime) {
                                if (!filter.isExcluded) {
                                    conditions.push(new Parse.Query(this.theClassName).equalTo(filter.column, filter.value.extra))
                                } else {
                                    conditions.push(new Parse.Query(this.theClassName).notEqualTo(filter.column, filter.value.extra))
                                }

                            } else if (filter.condition == 'exact') {
                                if (!filter.isExcluded) {
                                    if (this.isSubmissions) {
                                        conditions.push(new Parse.Query(this.theClassName).equalTo(filter.column, filter.value.valueToShow))
                                    } else {
                                        let english = new Parse.Query(this.theClassName).equalTo(filter.column + '_english', filter.value.valueToShow)
                                        let pashto = new Parse.Query(this.theClassName).equalTo(filter.column + '_pashto', filter.value.valueToShow)
                                        let dari = new Parse.Query(this.theClassName).equalTo(filter.column + '_dari', filter.value.valueToShow)
                                        conditions.push(Parse.Query.or(english, pashto, dari))
                                    }
                                } else {
                                    if (this.isSubmissions) {
                                        conditions.push(new Parse.Query(this.theClassName).notEqualTo(filter.column, filter.value.valueToShow))
                                    } else {
                                        let english = new Parse.Query(this.theClassName).notEqualTo(filter.column + '_english', filter.value.valueToShow)
                                        let pashto = new Parse.Query(this.theClassName).notEqualTo(filter.column + '_pashto', filter.value.valueToShow)
                                        let dari = new Parse.Query(this.theClassName).notEqualTo(filter.column + '_dari', filter.value.valueToShow)
                                        conditions.push(Parse.Query.or(english, pashto, dari))
                                    }
                                }

                                // one date
                            } else if (filter.condition == 'date') {
                                if (!filter.isExcluded) {
                                    var from = new Date(filter.value.extra.from)
                                    conditions.push(new Parse.Query(this.theClassName).greaterThanOrEqualTo(filter.column, moment(from).startOf('day').toDate()))
                                    conditions.push(new Parse.Query(this.theClassName).lessThan(filter.column, moment(from).add(1, 'day').toDate()))
                                } else {
                                    var from = new Date(filter.value.extra.from)
                                    let startCon = new Parse.Query(this.theClassName).lessThan(filter.column, moment(from).startOf('day').toDate())
                                    let endCon = new Parse.Query(this.theClassName).greaterThan(filter.column, moment(from).endOf('day').toDate())
                                    conditions.push(Parse.Query.or(startCon, endCon))
                                }

                                // data range
                            } else if (filter.condition == 'dateRange') {
                                var from = new Date(filter.value.extra.from)
                                var to = new Date(filter.value.extra.to)
                                if (!filter.isExcluded) {
                                    conditions.push(new Parse.Query(this.theClassName).greaterThanOrEqualTo(filter.column, moment(from).startOf('day').toDate()))
                                    conditions.push(new Parse.Query(this.theClassName).lessThanOrEqualTo(filter.column, moment(to).endOf('day').toDate()))
                                } else {
                                    conditions.push(Parse.Query.or(new Parse.Query(this.theClassName).lessThan(filter.column, moment(from).startOf('day').toDate()), new Parse.Query(this.theClassName).greaterThan(filter.column, moment(to).endOf('day').toDate())))
                                }

                            } else if (filter.type == "single-option") {
                                if (!filter.isExcluded) {
                                    conditions.push(new Parse.Query(this.theClassName).equalTo(filter.column, filter.value.extra))
                                } else {
                                    conditions.push(new Parse.Query(this.theClassName).notEqualTo(filter.column, filter.value.extra))
                                }
                            } else if (filter.type == 'select') {
                                if (Array.isArray(filter.value.extra)) {
                                    if (!filter.isExcluded) {
                                        conditions.push(new Parse.Query(this.theClassName).containedIn(filter.column, filter.value.extra))
                                    } else {
                                        conditions.push(new Parse.Query(this.theClassName).notContainedIn(filter.column, filter.value.extra))
                                    }
                                } else {

                                    if (!filter.isExcluded) {
                                        conditions.push(new Parse.Query(this.theClassName).equalTo(filter.column, filter.value.extra))
                                    } else {

                                        conditions.push(new Parse.Query(this.theClassName).notEqualTo(filter.column, filter.value.extra))
                                    }
                                }
                            } else if (filter.type == 'checkbox') {
                                conditions.push(new Parse.Query(this.theClassName).equalTo(filter.column, filter.value.extra))

                            } else if (filter.type == 'multiple-option') {
                                if (!filter.isExcluded)
                                    conditions.push(new Parse.Query(this.theClassName).containedIn(filter.column, filter.value.extra))
                                else conditions.push(new Parse.Query(this.theClassName).notContainedIn(filter.column, filter.value.extra))

                            } else if (filter.column == 'createdBy') {
                                let creators = []

                                filter.value.extra.forEach(user => {
                                    if (!filter.isExcluded)
                                        creators.push(new Parse.Query(this.theClassName).equalTo(filter.column, user.user))
                                    else
                                        creators.push(new Parse.Query(this.theClassName).notEqualTo(filter.column, user.user))
                                })
                                conditions.push(Parse.Query.or(...creators))

                            } else if (filter.column == 'approvalBy') {
                                let approvers = []

                                filter.value.extra.forEach(user => {
                                    if (!filter.isExcluded)
                                        approvers.push(new Parse.Query(this.theClassName).equalTo(filter.column, user.user))
                                    else
                                        approvers.push(new Parse.Query(this.theClassName).notEqualTo(filter.column, user.user))
                                })
                                conditions.push(Parse.Query.or(...approvers))

                            } else if (filter.column == 'status') {
                                let statuss = []
                                let andStatuss = []
                                filter.value.extra.forEach(status => {
                                    if (!filter.isExcluded)
                                        statuss.push(new Parse.Query(this.theClassName).equalTo('status', status))
                                    else {
                                        andStatuss.push(new Parse.Query(this.theClassName).notEqualTo('status', status))
                                    }
                                })
                                if (filter.isExcluded) conditions.push(Parse.Query.and(...andStatuss))
                                else
                                    conditions.push(Parse.Query.or(...statuss))
                            }
                        })
                    }
                    if (this.searchString != '') {
                        let searches = [];
                        if (this.isSubmissions) {
                            this.fields.forEach(field => {
                                if (field.type == 'text' || field.type == 'textarea') {

                                    if (field.type == 'text' && field.field.fieldType == 'number') {
                                        searches.push(new Parse.Query(this.theClassName).equalTo(field.key, parseFloat(this.searchString)));
                                    } else {
                                        searches.push(new Parse.Query(this.theClassName).matches(field.key, `^.*${this.searchString}.*`));
                                    }
                                }
                            })
                            if (searches.length == 0) searches.push(new Parse.Query(this.theClassName).notEqualTo('objectId', ''))
                            conditions.push(Parse.Query.or(...searches));
                        } else {
                            let englishLabel = new Parse.Query(this.theClassName).matches('label_english', `^.*${this.searchString}.*`)
                            let pashtoLabel = new Parse.Query(this.theClassName).matches('label_pashto', `^.*${this.searchString}.*`)
                            let dariLabel = new Parse.Query(this.theClassName).matches('label_dari', `^.*${this.searchString}.*`)

                            let descriptionEnglish = new Parse.Query(this.theClassName).matches('description_english', `^.*${this.searchString}.*`)
                            let descriptionPashto = new Parse.Query(this.theClassName).matches('description_pashto', `^.*${this.searchString}.*`)
                            let descriptionDari = new Parse.Query(this.theClassName).matches('description_dari', `^.*${this.searchString}.*`)

                            conditions.push(Parse.Query.or(englishLabel, pashtoLabel, dariLabel, descriptionEnglish, descriptionPashto, descriptionDari));
                        }
                    }
                    var mainQuery = Parse.Query.and(...conditions);

                    mainQuery.skip((pageNumber - 1) * 25)
                    mainQuery.limit(25)
                    mainQuery.descending('createdAt')

                    let results = await mainQuery.find();
                    // .then(results => {
                    this.records = results
                    this.allRecordsCount = results.length
                    this.$store.commit('setLoading', false)
                    // })
                    // .catch(error => {
                    //     this.$store.commit('setLoading', false)
                    // });
                    this.$refs.filterFieldsDropDown.close()
                }
            },


            filterFilesBasedOn(cat) {
                this.$store.commit("setLoading", true);
                var size = 10
                var queryBuilder = DB[this.className].find();
                var conditions = []
                var temp = []

                conditions.push(queryBuilder.equal('category', this.currentCategory));
                if (cat.value == 'image' || cat.value == 'video' || cat.value == 'pdf' || cat.value == 'audio') {
                    conditions.push(queryBuilder.matches('mime', `^.*${cat.value}.*`))
                } else if (cat.label == 'Presentations' || cat.label == 'Spreadsheets' || cat.label == 'Documents') {
                    cat.value.forEach(type => {
                        temp.push(queryBuilder.matches('mime', `^.*${type}.*`))
                    })
                    conditions.push(queryBuilder.or(temp))
                } else {
                    cat.value.forEach(type => {
                        temp.push(queryBuilder.matches('mime', `^(?!.*${type}.*)`))
                    })
                    conditions.push(queryBuilder.and(temp))
                }


                queryBuilder.and(conditions)
                    .resultList(result => {

                        if (result.length !== 0) {
                            this.setSearchedResult(result)
                            this.setSearchError('')
                        } else {
                            this.setSearchError(this._('No match was found'))
                            this.setSearchedResult([])
                        }
                        this.$store.commit("setLoading", false);
                    })
                this.$refs.fileTypes.close()
            },




            showConditions(field) {
                setTimeout(() => {
                    this.dropDown = 'second';
                    this.currentFilterField = field
                    if (field.key == 'name' || field.key == 'content') this.filterCondition = 'contains'
                    else if (field.key == 'createdAt' || field.key == 'updatedAt') this.filterCondition = 'date'
                }, 50);
            },


            getFieldLabel(labels) {

                if (this.selectedLang == 'dari') return labels.dari
                else if (this.selectedLang == 'pashto') return labels.pashto
                else return labels.english
            },

            removeFilter(index) {
                this.filters.splice(index, 1)
                this.search(1)
            },

            showFilter() {
                this.dropDown = 'second'
                this.$refs.filterFieldsDropDown.open()
            },

            getQuestionLabel(field) {
                let ret = field;
                for (var f in this.filterFields) {
                    if (this.filterFields[f].value == field) {

                        if (this.getSystemLanguage == 'dari') {
                            if (this.formLanguages.includes('dari')) ret = this.filterFields[f].label.dari
                            else {
                                if (this.formLanguages[0] == 'pashto') ret = this.filterFields[f].label.pashto
                                else ret = this.filterFields[f].label.english
                            }
                        }

                        if (this.getSystemLanguage == 'pashto') {
                            if (this.formLanguages.includes('pashto')) ret = this.filterFields[f].label.pashto
                            else {
                                if (this.formLanguages[0] == 'dari') ret = this.filterFields[f].label.dari
                                else ret = this.filterFields[f].label.english
                            }


                        } else {
                            if (this.formLanguages.includes('english')) ret = this.filterFields[f].label.english
                            else {
                                if (this.formLanguages[0] == 'pashto') ret = this.filterFields[f].label.pashto
                                else ret = this.filterFields[f].label.dari
                            }
                        }


                        // if (this.selectedLang == 'dari') ret = this.filterFields[f].label.dari
                        // else if (this.selectedLang == 'pashto') ret = this.filterFields[f].label.pashto
                        // else ret = this.filterFields[f].label.english
                        break;
                    }
                }
                return ret;
            },

            clearFields() {
                this.filterValue = ''
                this.filterCondition = ''
                this.filterFromDate = ''
                this.filterToDate = ''
                this.filterAgents = []
                this.dateRangeFilterLabel = ''
                this.isExcluded = false
            },

            lastSevenDays() {
                this.dateRangeFilterLabel = 'Past 7 Days'
                var currenctDate = new Date();
                var ts = currenctDate.getTime();
                var pastSevenDate = new Date(ts - (7 * 24 * 60 * 60 * 1000));

                this.filterFromDate = pastSevenDate.getFullYear() + '-' + (parseInt(pastSevenDate.getMonth()) + parseInt(1)) + '-' + pastSevenDate.getDate()
                this.filterToDate = currenctDate.getFullYear() + '-' + (parseInt(currenctDate.getMonth()) + parseInt(1)) + '-' + currenctDate.getDate()

            },

            thisMonth() {
                this.dateRangeFilterLabel = 'This Month'
                var date = new Date();
                var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

                this.filterFromDate = firstDay.getFullYear() + '-' + (parseInt(firstDay.getMonth()) + parseInt(1)) + '-' + firstDay.getDate()
                this.filterToDate = new Date().getFullYear() + '-' + (parseInt(new Date().getMonth()) + parseInt(1)) + '-' + new Date().getDate()

            },

            prevMonth() {
                this.dateRangeFilterLabel = 'Prev Month'
                var date = new Date();
                var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

                this.filterFromDate = firstDay.getFullYear() + '-' + (parseInt(firstDay.getMonth())) + '-' + firstDay.getDate()

                firstDay.setDate(1);
                firstDay.setHours(-1);

                this.filterToDate = firstDay.getFullYear() + '-' + (parseInt(firstDay.getMonth()) + parseInt(1)) + '-' + firstDay.getDate()
            },

            lastThreeMonths() {
                this.dateRangeFilterLabel = 'Last 3 Months'
                var currenctDate = new Date()
                this.filterToDate = currenctDate.getFullYear() + '-' + (parseInt(currenctDate.getMonth()) + parseInt(1)) + '-' + currenctDate.getDate()
                currenctDate.setMonth(currenctDate.getMonth() - 3);
                currenctDate.setDate(1);
                currenctDate.setHours(1);
                this.filterFromDate = currenctDate.getFullYear() + '-' + (parseInt(currenctDate.getMonth())) + '-' + currenctDate.getDate()

            },

            thisYear() {
                this.dateRangeFilterLabel = 'This Year'
                var thisYear = new Date(new Date().getFullYear(), 0, 1);
                this.filterFromDate = thisYear.getFullYear() + '-' + (parseInt(thisYear.getMonth()) + parseInt(1)) + '-' + thisYear.getDate()
                this.filterToDate = new Date().getFullYear() + '-' + (parseInt(new Date().getMonth()) + parseInt(1)) + '-' + new Date().getDate()

            },

            prevYear() {
                this.dateRangeFilterLabel = 'Prev Year'
                var lastyearStart = new Date(new Date().getFullYear() - 1, 0, 1);
                var lastYearEnd = (new Date(lastyearStart.getFullYear(), 11, 31))

                this.filterFromDate = lastyearStart.getFullYear() + '-' + (parseInt(lastyearStart.getMonth()) + parseInt(1)) + '-' + lastyearStart.getDate()
                this.filterToDate = lastYearEnd.getFullYear() + '-' + (parseInt(lastYearEnd.getMonth()) + parseInt(1)) + '-' + lastYearEnd.getDate()

            },

            fetchUsers(ids) {
                var promises = []
                ids.forEach(id => {
                    promises.push(new Promise((resolve, reject) => {
                        DB.UserProfile.load(id)
                            .then(user => {
                                resolve(user)
                            })
                    }))
                })
                return promises
            },

            applyFetchedFilter(filter) {
                var filterValue
                if (filter.type == 'date') {
                    if (filter.field) {
                        if (filter.field.isTime) {
                            if (filter.value.extra) {
                                filterValue = {
                                    valueToShow: moment.utc(filter.value.extra * 1000).format('HH:mm:ss'),
                                    extra: filter.value.extra
                                }
                            } else {
                                filterValue = {
                                    valueToShow: '',
                                    extra: 0
                                }
                            }

                        } else {
                            var from = filter.value.extra.from !== '' ? new Date(filter.value.extra.from).getFullYear() + '/' + parseInt(new Date(filter.value.extra.from).getMonth() + parseInt(1)) + '/' + new Date(filter.value.extra.from).getDate() : ''
                            var to = filter.value.extra.to !== '' ? new Date(filter.value.extra.to).getFullYear() + '/' + parseInt(new Date(filter.value.extra.to).getMonth() + parseInt(1)) + '/' + new Date(filter.value.extra.to).getDate() : ''



                            filterValue = {
                                valueToShow: filter.value.valueToShow,
                                extra: {
                                    from: from || '',
                                    to: to || ''
                                }
                            }
                        }
                    }

                } else if (filter.type == 'checkbox') {
                    filterValue = {
                        valueToShow: filter.value.extra == true ? this._('Yes') : this._('No'),
                        extra: filter.value.extra
                    }
                } else if (filter.type == 'text' && filter.field.fieldType == 'number') {
                    filterValue = { valueToShow: parseFloat(filter.value.valueToShow) }

                } else filterValue = filter.value

                this.filters.push({
                    value: filterValue,
                    column: filter.column,
                    condition: filter.condition,
                    isExcluded: filter.isExcluded,
                    type: filter.type,
                    field: filter.field
                })
            },

            fetchFilter(filterId) {
                return new Promise((resolve, reject) => {
                    let q = new Parse.Query('Filter')
                    q.get(filterId)
                        .then(result => {
                            this.viewedFilterObj = result
                            this.filterTitle = this.viewedFilterObj.get('label_english')
                            this.filterTitlePashto = this.viewedFilterObj.get('label_pashto')
                            this.filterTitleDari = this.viewedFilterObj.get('label_dari')
                            this.showInSidebar = this.viewedFilterObj.get('show_in_sidebar')

                            result.get('filters').forEach(async filter => {

                                if (Array.isArray(filter.value.extra)) {
                                    // await Promise.all(this.fetchUsers(filter.value.extra))
                                    //     .then(res => {

                                    //         this.filterUsers = res
                                    //     })
                                }


                                this.applyFetchedFilter(filter)
                                resolve('hello')
                            })
                        })
                })
            },

            async makeFields() {
                if (this.$route.matched[0].name == 'surveys') this.className = 'Form'
                else if (this.$route.matched[0].name == 'articles') this.className = 'Article'
                else if (this.$route.matched[0].name == 'files') this.className = 'File'
                else this.className = 'Map'

                if (this.$route.matched[0].name != 'surveys') {

                    this.filterFields.push({ type: 'text', key: 'label', label: { english: 'Name', pashto: 'نوم', dari: 'نام' }, field: { fieldType: 'text' } });
                    this.filterFields.push({ type: 'text', key: 'description', label: { english: 'Description', pashto: 'منځپانګې', dari: 'محتوا' }, field: { fieldType: 'text' } });
                    this.filterFields.push({ type: 'createdBy', key: 'createdBy', label: { english: 'Created By', pashto: 'جوړونکۍ', dari: 'ایجاد کننده' }, field: { fieldType: '' } });
                    this.filterFields.push({ type: 'date', key: 'createdAt', label: { english: 'Created At', pashto: 'تاریخ د جوړیدو', dari: 'تاریخ ایجاد' }, field: { fieldType: '' } });
                    this.filterFields.push({ type: 'status', key: 'status', label: { english: 'Status', pashto: 'حالت', dari: 'وضعیت' }, field: { fieldType: '' } });

                    if (this.user && !this.user.get('roles').includes('guest')) this.filterFields.push({ type: 'approvalBy', key: 'approvalBy', label: { english: 'Approval By', pashto: 'منل شوی د', dari: 'تایید شده توسط' }, field: { fieldType: '' } });
                    let tmpFields = [];
                    tmpFields.push({ show: true, type: 'text', key: 'label', label: { english: 'Name', pashto: 'نوم', dari: 'نام' }, field: { fieldType: 'text' } });
                    tmpFields.push({ show: true, type: 'text', key: 'description', label: { english: 'Content', pashto: 'منځپانګې', dari: 'محتوا' }, field: { fieldType: 'text' } });
                    tmpFields.push({ show: true, type: 'createdBy', key: 'createdBy', label: { english: 'Created By', pashto: 'جوړونکۍ', dari: 'ایجاد کننده' }, field: { fieldType: '' } });
                    tmpFields.push({ show: true, type: 'date', key: 'createdAt', label: { english: 'Created At', pashto: 'تاریخ د جوړیدو', dari: 'تاریخ ایجاد' }, field: { fieldType: '' } });
                    tmpFields.push({ show: true, type: 'status', key: 'status', label: { english: 'Status', pashto: 'حالت', dari: 'وضعیت' }, field: { fieldType: '' } });
                    if (this.user && !this.user.get('roles').includes('guest')) tmpFields.push({ show: true, type: 'approvalBy', key: 'approvalBy', label: { english: 'Approval By', pashto: 'منل شوی د', dari: 'تایید شده توسط' }, field: { fieldType: '' } });
                    tmpFields.push({ show: true, type: 'action', key: 'action', label: { english: 'Action', pashto: 'کړنه', dari: 'عملیه' }, field: { fieldType: '' } });
                    this.fields = tmpFields;

                    let showCols = [];
                    showCols.push('label');
                    // showCols.push('description');
                    showCols.push('createdBy');
                    showCols.push('createdAt');
                    showCols.push('status');
                    if (this.user && !this.user.get('roles').includes('guest')) showCols.push('approvalBy');
                    showCols.push('action');


                    this.showColumns = showCols;


                } else {

                    let q = new Parse.Query('Form')
                    q.equalTo('class_name', 'Data_' + this.$route.params.form_slug)

                    this.viewedForm = await q.first()

                    let submissionApprovers = await this.viewedForm.get("survey_submission_approvers")
                    this.viewedForm['submissionApprovers'] = submissionApprovers

                    this.formLanguages = this.viewedForm.get('form_languages')

                    let fields = [];
                    let filterFields = []
                    let showCols = [];
                    let i = 0;
                    this.viewedForm.get('layout').map(field => {
                        if (field.type !== 'heading' && field.type !== 'description') {

                            if (field.type !== 'attachment' && field.type !== 'single-geolocation' && field.type !== 'multiple-geolocation') {
                                i++;

                                fields.push({
                                    key: field.fieldDatabaseName,
                                    field: field,
                                    label: {
                                        english: field.englishLabel,
                                        pashto: field.pashtoLabel,
                                        dari: field.dariLabel
                                    },
                                    show: i < 5,
                                    type: field.type,
                                    options: field.type == 'multiple-option' || field.type ==
                                        'single-option' || field.type == 'select' ? field.options :
                                        []
                                });
                                filterFields.push({
                                    key: field.fieldDatabaseName,
                                    field: field,
                                    label: {
                                        english: this.viewedForm.get('form_languages').includes(
                                            'english') ? field.englishLabel : '',
                                        pashto: this.viewedForm.get('form_languages').includes(
                                            'pashto') ? field.pashtoLabel : '',
                                        dari: this.viewedForm.get('form_languages').includes('dari') ?
                                            field.dariLabel : ''
                                    },
                                    value: field.fieldDatabaseName,
                                    type: field.type,
                                    options: field.type == 'multiple-option' || field.type ==
                                        'single-option' || field.type == 'select' ? field.options :
                                        []
                                })
                                if (i < 5) showCols.push(field.fieldDatabaseName);
                            }
                            // if (i < 5 && field.type !== 'attachment') 
                        }
                    });
                    fields = [
                        ...fields,
                        {
                            key: 'createdAt',
                            field: { fieldType: '' },
                            label: {
                                english: this.viewedForm.get('form_languages').includes('english') ? 'Created At' :
                                    '',
                                pashto: this.viewedForm.get('form_languages').includes('pashto') ?
                                    'تاریخ د جوړیدو' : '',
                                dari: this.viewedForm.get('form_languages').includes('dari') ? 'تاریخ ایجاد' : ''
                            },
                            show: (fields.length < 4),
                            type: 'date'
                        },
                        {
                            key: 'updatedAt',
                            field: { fieldType: '' },
                            label: {
                                english: this.viewedForm.get('form_languages').includes('english') ? 'Updated At' :
                                    '',
                                pashto: this.viewedForm.get('form_languages').includes('pashto') ?
                                    'تاریخ  اوسمهال کول' : '',
                                dari: this.viewedForm.get('form_languages').includes('dari') ?
                                    'تاریخ دست کاری شده' : ''
                            },
                            show: (fields.length < 3),
                            type: 'date'
                        },
                        // {
                        //     key: 'status',
                        //     field: { fieldType: '' },
                        //     label: {
                        //         english: this.viewedForm.get('form_languages').includes('english') ? 'Status' : '',
                        //         pashto: this.viewedForm.get('form_languages').includes('pashto') ? 'حالت' : '',
                        //         dari: this.viewedForm.get('form_languages').includes('dari') ? 'وضعیت' : ''
                        //     },
                        //     show: (fields.length < 2),
                        //     type: 'status'
                        // },
                        {
                            key: 'createdBy',
                            field: { fieldType: '' },
                            label: {
                                english: this.viewedForm.get('form_languages').includes('english') ? 'Created By' : '',
                                pashto: this.viewedForm.get('form_languages').includes('pashto') ? 'استازی' : '',
                                dari: this.viewedForm.get('form_languages').includes('dari') ? 'عامل' : ''
                            },
                            show: false,
                            type: 'createdBy'
                        }
                    ]
                    if (this.viewedForm && this.viewedForm.get('submission_require_approval')) {
                        fields.push({
                            key: 'status',
                            field: { fieldType: '' },
                            label: {
                                english: this.viewedForm.get('form_languages').includes('english') ? 'Status' : '',
                                pashto: this.viewedForm.get('form_languages').includes('pashto') ? 'حالت' : '',
                                dari: this.viewedForm.get('form_languages').includes('dari') ? 'وضعیت' : ''
                            },
                            show: (fields.length < 2),
                            type: 'status'
                        })
                    }
                    filterFields = [
                        ...filterFields,
                        {
                            key: 'createdAt',
                            field: { fieldType: '' },
                            value: 'createdAt',
                            label: {
                                english: this.viewedForm.get('form_languages').includes('english') ? 'Created At' :
                                    '',
                                pashto: this.viewedForm.get('form_languages').includes('pashto') ?
                                    'تاریخ د جوړیدو' : '',
                                dari: this.viewedForm.get('form_languages').includes('dari') ? 'تاریخ ایجاد' : ''
                            },
                            type: 'date',
                            options: []
                        },
                        {
                            key: 'updatedAt',
                            field: { fieldType: '' },
                            value: 'updatedAt',
                            label: {
                                english: this.viewedForm.get('form_languages').includes('english') ? 'Updated At' :
                                    '',
                                pashto: this.viewedForm.get('form_languages').includes('pashto') ?
                                    'تاریخ  اوسمهال کول' : '',
                                dari: this.viewedForm.get('form_languages').includes('dari') ?
                                    'تاریخ دست کاری شده' : ''
                            },
                            type: 'date',
                            options: []
                        },
                        // {
                        //     key: 'status',
                        //     field: { fieldType: '' },
                        //     value: 'status',
                        //     label: {
                        //         english: this.viewedForm.get('form_languages').includes('english') ? 'Status' : '',
                        //         pashto: this.viewedForm.get('form_languages').includes('pashto') ? 'حالت' : '',
                        //         dari: this.viewedForm.get('form_languages').includes('dari') ? 'وضعیت' : ''
                        //     },
                        //     type: 'status',
                        //     options: []
                        // },
                        {
                            key: 'createdBy',
                            field: { fieldType: '' },
                            value: 'createdBy',
                            label: {
                                english: this.viewedForm.get('form_languages').includes('english') ? 'Created By' : '',
                                pashto: this.viewedForm.get('form_languages').includes('pashto') ? 'استازی' : '',
                                dari: this.viewedForm.get('form_languages').includes('dari') ? 'عامل' : ''
                            },
                            type: 'createdBy',
                            options: []
                        }
                    ]

                    if (this.viewedForm && this.viewedForm.get('submission_require_approval')) {
                        filterFields.push({
                            key: 'status',
                            field: { fieldType: '' },
                            value: 'status',
                            label: {
                                english: this.viewedForm.get('form_languages').includes('english') ? 'Status' : '',
                                pashto: this.viewedForm.get('form_languages').includes('pashto') ? 'حالت' : '',
                                dari: this.viewedForm.get('form_languages').includes('dari') ? 'وضعیت' : ''
                            },
                            type: 'status',
                            options: []
                        })
                    }
                    if (i < 4) showCols.push('createdAt');
                    if (i < 3) showCols.push('updatedAt');
                    if (i < 2) showCols.push('status');

                    this.fields = fields;
                    this.showColumns = showCols;
                    this.filterFields = filterFields
                }
            },

            async fetchRecords(pageNumber) {
                var conditions = []

                if (this.theClassName) {
                    conditions.push(new Parse.Query(this.theClassName).notEqualTo('objectId', ''))


                    if (this.user.get('roles').includes('guest')) {
                        if (this.isSubmissions) {
                            if (this.viewedForm.get('submission_require_approval'))
                                conditions.push(new Parse.Query(this.theClassName).equalTo('status', 'approved'))
                        } else {
                            conditions.push(new Parse.Query(this.theClassName).equalTo('shared_with', this.user))
                            conditions.push(new Parse.Query(this.theClassName).equalTo('status', 'approved'))
                        }
                    } else if (!this.user.get('roles').includes('guest')) {
                        conditions.push(new Parse.Query(this.theClassName).equalTo('category', this.getCategory))
                        // conditions.push(new Parse.Query(this.theClassName).equalTo('department', this.currentDepartment))
                    }

                    if (this.isSubmissions) {
                        if (this.$route.meta.isPublicView) {
                            // check survey of submission approval is on
                            if (this.viewedForm.get('submission_require_approval') && this.viewedForm.get('survey_submission_approvers') != null && this.viewedForm.get('survey_submission_approvers').length != 0) {
                                conditions.push(new Parse.Query(this.theClassName).equalTo('status', 'approved'));
                            }
                        } else {
                            if (!this.user.get('roles').includes('admin') && !this.user.get('roles').includes('manager') && !this.user.get('roles').includes('survey-editor')) {
                                var orTemp = [];
                                if (this.user.get('roles').includes('submitter'))
                                    orTemp.push(new Parse.Query(this.theClassName).equalTo('createdBy', this.user))

                                // for submission approvers
                                if (this.user.get('roles').includes('submission-approver')) {
                                    orTemp.push(new Parse.Query(this.theClassName).equalTo('approvalBy', this.user))

                                    if (this.viewedForm.get('submission_require_approval')) {
                                        if (this.viewedForm.get('survey_submission_approvers')) {
                                            for (let i = 0; i < this.viewedForm.get('survey_submission_approvers').length; i++) {
                                                const approver = this.viewedForm.get('survey_submission_approvers')[i];
                                                if (approver && approver.id == this.user.id) {
                                                    orTemp.push(new Parse.Query(this.theClassName).equalTo('status', 'pending'))
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }



                                if (this.user.get('roles').includes('survey-viewer') && this.viewedForm.get('submission_require_approval')) {
                                    orTemp.push(new Parse.Query(this.theClassName).equalTo('status', 'approved'))
                                }
                                if (orTemp.length == 0) orTemp.push(new Parse.Query(this.theClassName).notEqualTo('objectId', ''))
                                conditions.push(Parse.Query.or(...orTemp))
                            }
                        }
                    } else {
                        if (!this.user.get('roles').includes('admin') && !this.user.get('roles').includes('manager') && !this.user.get('roles').includes(this.section + '-editor')) {
                            var orTemp = [];
                            if (this.user.get('roles').includes(this.section + '-creator'))
                                orTemp.push(new Parse.Query(this.theClassName).equalTo('createdBy', this.user))

                            // for section approvers
                            if (this.user.get('roles').includes(this.section + '-approver')) {
                                orTemp.push(new Parse.Query(this.theClassName).equalTo('approvalBy', this.user))
                                orTemp.push(new Parse.Query(this.theClassName).equalTo('approvers', this.user))
                            }

                            if (this.user.get('roles').includes(this.section + '-viewer')) {
                                orTemp.push(new Parse.Query(this.theClassName).equalTo('status', 'approved'))
                            }
                            if (orTemp.length == 0) orTemp.push(new Parse.Query(this.theClassName).notEqualTo('objectId', ''))
                            conditions.push(Parse.Query.or(...orTemp))
                        }
                    }
                    var limit = 10;
                    if (this.$route && this.$route.query && this.$route.query['perPage']) {
                        limit = parseInt(this.$route.query['perPage'])
                    } else {
                        limit = 10
                    }


                    var mainQuery = Parse.Query.and(...conditions);
                    mainQuery.skip((pageNumber - 1) * limit)
                    mainQuery.limit(limit)
                    mainQuery.descending('createdAt')
                    mainQuery.include('createdBy')
                    mainQuery.include('approvalBy')
                    if (!this.isSubmissions) {
                        mainQuery.include('meta_form_layout')
                        mainQuery.include('shared_with')
                    }
                    this.records = await mainQuery.find();

                    // this.records = await q.find()
                    this.$store.commit('setLoading', false)
                }
            },

            async fetchRecordsCount() {
                var conditions = []

                if (this.theClassName) {
                    conditions.push(new Parse.Query(this.theClassName).notEqualTo('objectId', ''))

                    if (this.user.get('roles').includes('guest')) {
                        if (this.isSubmissions) {
                            if (this.viewedForm.get('submission_require_approval'))
                                conditions.push(new Parse.Query(this.theClassName).equalTo('status', 'approved'))
                        } else {
                            conditions.push(new Parse.Query(this.theClassName).equalTo('shared_with', this.user))
                            conditions.push(new Parse.Query(this.theClassName).equalTo('status', 'approved'))
                        }
                    } else if (!this.user.get('roles').includes('guest')) {
                        conditions.push(new Parse.Query(this.theClassName).equalTo('category', this.getCategory))
                        // conditions.push(new Parse.Query(this.theClassName).equalTo('department', this.currentDepartment))
                    }

                    if (this.isSubmissions) {
                        if (this.$route.meta.isPublicView) {
                            // check survey of submission approval is on
                            if (this.viewedForm.get('submission_require_approval') && this.viewedForm.get('survey_submission_approvers') != null && this.viewedForm.get('survey_submission_approvers').length != 0) {
                                conditions.push(new Parse.Query(this.theClassName).equalTo('status', 'approved'));
                            }
                        } else {
                            if (!this.user.get('roles').includes('admin') && !this.user.get('roles').includes('manager') && !this.user.get('roles').includes('survey-editor')) {
                                var orTemp = [];
                                if (this.user.get('roles').includes('submitter'))
                                    orTemp.push(new Parse.Query(this.theClassName).equalTo('createdBy', this.user))

                                // for submission approvers
                                if (this.user.get('roles').includes('submission-approver')) {
                                    orTemp.push(new Parse.Query(this.theClassName).equalTo('approvalBy', this.user))

                                    if (this.viewedForm.get('submission_require_approval')) {
                                        if (this.viewedForm.get('survey_submission_approvers')) {
                                            for (let i = 0; i < this.viewedForm.get('survey_submission_approvers').length; i++) {
                                                const approver = this.viewedForm.get('survey_submission_approvers')[i];
                                                if (approver && approver.id == this.user.id) {
                                                    orTemp.push(new Parse.Query(this.theClassName).equalTo('status', 'pending'))
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }


                                if (this.user.get('roles').includes('survey-viewer') && this.viewedForm.get('submission_require_approval')) {
                                    orTemp.push(new Parse.Query(this.theClassName).equalTo('status', 'approved'))
                                }
                                if (orTemp.length == 0) orTemp.push(new Parse.Query(this.theClassName).notEqualTo('objectId', ''))
                                conditions.push(Parse.Query.or(...orTemp))
                            }
                        }
                    } else {
                        if (!this.user.get('roles').includes('admin') && !this.user.get('roles').includes('manager') && !this.user.get('roles').includes(this.section + '-editor')) {
                            var orTemp = [];
                            if (this.user.get('roles').includes(this.section + '-creator'))
                                orTemp.push(new Parse.Query(this.theClassName).equalTo('createdBy', this.user))

                            // for section approvers
                            if (this.user.get('roles').includes(this.section + '-approver')) {
                                orTemp.push(new Parse.Query(this.theClassName).equalTo('approvalBy', this.user))
                                orTemp.push(new Parse.Query(this.theClassName).equalTo('approvers', this.user))
                            }

                            if (this.user.get('roles').includes(this.section + '-viewer')) {
                                orTemp.push(new Parse.Query(this.theClassName).equalTo('status', 'approved'))
                            }
                            if (orTemp.length == 0) orTemp.push(new Parse.Query(this.theClassName).notEqualTo('objectId', ''))
                            conditions.push(Parse.Query.or(...orTemp))
                        }
                    }
                    var mainQuery = Parse.Query.and(...conditions);
                    this.allRecordsCount = await mainQuery.count();
                }
            },

            async fetchings() {
                this.$store.commit('setLoading', true)
                this.category = this.getCurrentCategory
                this.currentDepartment = this.getCurrentDepartment
                if (this.$route.meta.isPublicView && this.isSubmissions) {
                    // 1. set the viewedForm
                    var formSlug = this.$route.params.form_slug;
                    var surveyId = this.$route.params.surveyId;
                    var res = await this.g_fetchObject(surveyId, 'Form')
                    this.viewedForm = res

                    this.section = 'survey';
                    this.setSystemLanguage('english')
                    if (this.viewedForm != null && this.viewedForm.get('is_enabled') && false) {
                        await this.fetchRecordsCount()
                        await this.fetchRecords(1)
                    }
                }
                await this.makeFields()

                if (!this.$route.meta.isPublicView) this.section = this.$route.matched[0].name.substring(0, this.$route.matched[0].name.length - 1)
                if (this.isSubmissions) {
                    this.theClassName = this.viewedForm.get('class_name')

                } else {
                    this.theClassName = this.section.charAt(0).toUpperCase() + this.section.slice(1)
                }

                if (this.$route.query.filterId) {

                    this.fetchFilter(this.$route.query.filterId)
                        .then(res => {
                            this.search(1)
                        })
                } else {
                    await this.fetchRecordsCount()
                    await this.fetchRecords(1)
                }
            }
        },


        async mounted() {
            await this.fetchings()
        }
    }
</script>

<style>
    .search_wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
    }

    .filter {
        display: flex;
        flex-direction: row;
        margin-right: 8px;
    }

    .filter_btn {
        margin-top: 10px;
        margin-right: 10px;
        zoom: 0.85
    }

    .filter_back_btn {
        position: absolute;
        left: 1px;
        top: 11px;
        zoom: 0.85
    }

    .filter_value .va-col-sm-10 {
        padding: 0
    }


    /*  */

    .field_chip {
        background: #333;
        color: white;
        border-radius: 3px;
        height: 28px;
        /* max-width: 100px; */
        display: flex;
        padding: 0px 4px;
    }

    .field_chip_exclude {
        background: #8e1c00;
        color: white;
        border-radius: 3px;
        height: 28px;
        /* max-width: 100px; */
        display: flex;
        padding: 0px 4px;
    }

    .chip_text {
        font-size: 0.8em;
        height: 17px;
        margin-top: 4px;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1 !important
    }

    .shortcut-btns {
        margin: 5px 5px 5px 0
    }

    .filter_question {
        font-weight: bold;
        font-size: 18px;
        padding: 10px 0px 10px 10px;
        color: #666;
        margin-top: 36px;
    }

    .agent_email {
        width: 130px;
        position: absolute;
        top: 15%;
        margin-left: 10px;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .agent_name {
        position: absolute;
        top: 45%;
        margin-left: 10px;
        color: gray;
        font-size: 12px;
        width: 130px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .exclude_checkbox {
        position: absolute !important;
        right: 11px;
        top: 18px;
    }

    .filter_drop_down .position-right-top {
        top: 100% !important;
        bottom: auto !important;
        left: 0 !important;
        right: auto !important;
    }

    .filter_drop_down .va-dropdown-menu>div>li>a {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
        -webkit-box-pack: justify !important;
        -ms-flex-pack: justify !important;
        justify-content: space-between !important;
        padding: 5px 12px !important;
        color: #172b4d !important;
        width: 250px;
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        line-height: 1.5 !important;
    }

    .filter_drop_down .va-dropdown-menu>div>li>a:hover {
        text-decoration: none !important;
        background-color: #f4f5f7 !important;
    }

    .back_btn {
        /* background: red !important; */
        position: absolute;
        right: 22px;
        top: 35px;
    }

    .back_btn_toRight {
        position: absolute;
        right: 140px;
        top: 35px;
    }


    .submission_col_checkbox .va-checkbox-label {
        max-width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .deadCenter {
        width: 100%;
        bottom: 0;
        height: 100px;
        left: 0;
        margin: auto;
        position: relative;
        top: 0;
        right: 0;
        text-align: center;
    }

    .datatable td {
        overflow: hidden;
    }

    .smallPadding {
        padding: 4px 0px 4px 8px !important;
    }

    .mediumPadding {
        padding: 8px !important;
    }

    .largePadding {
        padding: 12px 8px !important;
    }


    .w100 {
        padding: 0px;
        max-width: 100px;
    }

    .w200 {
        padding: 0px;
        max-width: 200px;
    }

    .field_chip {
        background: #333;
        color: white;
        border-radius: 3px;
        height: 28px;
        /* max-width: 100px; */
        display: flex;
        padding: 0px 4px;
    }

    .field_chip_exclude {
        background: #8e1c00;
        color: white;
        border-radius: 3px;
        height: 28px;
        /* max-width: 100px; */
        display: flex;
        padding: 0px 4px;
    }

    .chip-text {
        font-size: 0.8em;
        height: 17px;
        margin-top: 4px;
        /* max-width: 100px; */
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1 !important
    }


    .va-dropdown-con .va-dropdown-menu>div>li>a {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        padding: 5px 12px;
        color: #172b4d;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.5;
    }

    .va-dropdown-con .va-dropdown-menu>div>li>a:hover {
        text-decoration: none;
        background-color: #f4f5f7;
    }

    .shortcut-btns {
        margin: 5px 5px 5px 0
    }

    .filter_question {
        font-weight: bold;
        font-size: 18px;
        padding: 10px 0px 10px 10px;
        color: #666;
    }

    .agent-email {
        width: 130px;
        position: absolute;
        top: 15%;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .agent-name {
        position: absolute;
        top: 45%;
        color: gray;
        font-size: 12px;
        width: 130px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .back_btn {
        /* background: red !important; */
        position: absolute;
        right: 22px;
        top: 35px;
    }

    .back_btn_toRight {
        position: absolute;
        right: 140px;
        top: 35px;
    }

    .showColDropDownLtr {
        zoom: 0.8;
        position: absolute !important;
        right: 8px;
        margin-top: 24px
    }

    .showColDropDownRtl {
        zoom: 0.8;
        position: absolute !important;
        left: 8px;
        margin-top: 24px
    }

    .labelRtl {
        position: absolute;
        font-size: 0.59em;
        background: #eee;
        line-height: 13px;
        padding: 0px 2px;
        font-weight: normal;
        top: 0;
        left: 0;
        font-family: verdana;
    }

    .labelLtr {
        position: absolute;
        font-size: 0.59em;
        background: #eee;
        line-height: 13px;
        padding: 0px 2px;
        font-weight: normal;
        top: 0;
        right: 0;
        font-family: verdana;
    }

    .entry_row {
        cursor: pointer;
        border-bottom: 1px solid #aaa3;
    }

    .approved_entry {
        position: absolute;
        font-size: 0.59em;
        background: #c9ffc1;
        line-height: 13px;
        padding: 0px 2px;
        font-weight: normal;
        top: 0;
        right: 0;
        font-family: verdana;
    }

    .rejected_entry {
        position: absolute;
        font-size: 0.59em;
        background: #ffd4d4;
        line-height: 13px;
        padding: 0px 2px;
        font-weight: normal;
        top: 0;
        right: 0;
        font-family: verdana;
    }

    .no_click {
        pointer-events: none;
    }

    .fieldTitle a {
        width: 50%;
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
    }

    .fieldTitle a {
        width: 100% !important;
    }

    .search_wrapper .va-dropdown-con .va-dropdown-menu {
        max-height: initial !important;
        overflow: visible !important;
        width: 400px;
    }
</style>